/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(async function(algolia) {
  'use strict';

  var cnmcCollectionHandleMatch = (window.location.pathname || '').match(
    /\/collections\/([^/?#]+)/i
  );
  var cnmcCollectionHandle =
    cnmcCollectionHandleMatch && cnmcCollectionHandleMatch[1];
  var cnmcBypassAlgoliaCollectionHandles = {
    'certified-pre-owned-instruments': true,
  };

  if (
    cnmcCollectionHandle &&
    cnmcBypassAlgoliaCollectionHandles[cnmcCollectionHandle]
  ) {
    algolia.config.instant_search_enabled_on_collection = false;
    algolia.config.collection_search_feature_enabled = false;

    if (algolia.contentHide && algolia.contentHide.parentNode) {
      algolia.contentHide.parentNode.removeChild(algolia.contentHide);
    }
  }

  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var index_suffix = await algolia.config.index_suffix;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;
  var isSheetMusicStandalonePage = Boolean(algolia.sheetMusicStandalonePage);
  var isSheetMusicCollectionPath = Boolean(
    (window.location.pathname || '').match(/\/collections\/sheet-music(?:\/|$)/i)
  );

  if (algolia.sheetMusicMode && isSheetMusicStandalonePage) {
    algolia.full_results = true;
    algolia.config.instant_search_enabled = true;
    algolia.config.results_selector = '#repertoire-search';
  }

  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;

  if (!algolia.full_results && !algolia.is_collection_results_page) {
    /**
     * If we aren't on the search page and neither on a collection page,
     * then there's no need to proceed
     */
    return;
  } else if (algolia.full_results) {
    /**
     * If we are on the search page and instant search isn't enabled,
     * then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled) {
      return;
    }
  } else if (algolia.is_collection_results_page) {
    /**
     * If we are on a collection page and instant search on collection isn't
     * enabled, then there's no need to proceed
     */
    if (!algolia.config.instant_search_enabled_on_collection) {
      return;
    }
  }

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];

  var collectionFacetFilter = null;
  var collectionRulesContextValue = null;
  var collectionHandle = null;
  var isSheetMusicCollection = false;
  var isSheetMusicExperience = isSheetMusicStandalonePage;

  var buildSheetMusicTagScopeFilter = function(tagScopeValues) {
    var normalizedScope = {};
    var tagScope = (tagScopeValues || [])
      .map(function(tag) {
        return tag && tag.trim ? tag.trim() : '';
      })
      .filter(function(tag) {
        return Boolean(tag);
      })
      .filter(function(tag) {
        var key = tag.toLowerCase();

        if (normalizedScope[key]) {
          return false;
        }

        normalizedScope[key] = true;
        return true;
      })
      .map(function(tag) {
        var escapedTag = tag.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        return 'tags:"' + escapedTag + '"';
      });

    if (tagScope.length > 0) {
      return '(' + tagScope.join(' OR ') + ')';
    }

    return null;
  };

  var buildSheetMusicMasterCollectionFilter = function() {
    var masterCollectionId = algolia.sheetMusicMasterCollectionId;
    var masterCollectionHandle = algolia.sheetMusicMasterCollectionHandle;

    if (algolia.config.collection_id_indexing && masterCollectionId) {
      return 'collection_ids:"' + masterCollectionId + '"';
    }

    if (masterCollectionHandle) {
      return 'collections:"' + masterCollectionHandle + '"';
    }

    return null;
  };

  // CNMC_SHEET_MUSIC_COLLECTION_SCOPE_20260721
  var sheetMusicCollectionScope = null;

  if (isSheetMusicStandalonePage && window.URLSearchParams) {
    var sheetMusicScopeParams = new URLSearchParams(window.location.search || '');
    var sheetMusicScopeHandle = (sheetMusicScopeParams.get('collection') || '').trim();
    var sheetMusicScopeId = (sheetMusicScopeParams.get('collection_id') || '').trim();
    var sheetMusicScopeLabel = (sheetMusicScopeParams.get('collection_label') || '').trim();
    var validSheetMusicScopeHandle = /^[a-z0-9][a-z0-9-]{0,127}$/.test(
      sheetMusicScopeHandle
    );
    var validSheetMusicScopeId = /^\d+$/.test(sheetMusicScopeId);

    if (validSheetMusicScopeHandle) {
      var sheetMusicScopeFilter = null;

      if (algolia.config.collection_id_indexing && validSheetMusicScopeId) {
        sheetMusicScopeFilter = 'collection_ids:"' + sheetMusicScopeId + '"';
      } else {
        sheetMusicScopeFilter = 'collections:"' + sheetMusicScopeHandle + '"';
      }

      sheetMusicCollectionScope = {
        handle: sheetMusicScopeHandle,
        id: validSheetMusicScopeId ? sheetMusicScopeId : '',
        label:
          sheetMusicScopeLabel.slice(0, 100) ||
          sheetMusicScopeHandle.replace(/-/g, ' '),
        filter: sheetMusicScopeFilter,
      };
    }
  }

  if (collectionPageEnabled) {
    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
    collectionHandle =
      Boolean(matches) && matches.length === 2 ? matches[1] : null;

    isSheetMusicCollection = collectionHandle === 'sheet-music';

    if (isSheetMusicCollection) {
      if (algolia.config.collection_id_indexing) {
        collectionFacetFilter = algolia.current_collection_id
          ? 'collection_ids:"' + algolia.current_collection_id + '"'
          : null;
      } else {
        collectionFacetFilter = 'collections:"' + collectionHandle + '"';
      }

      var shouldApplySheetMusicTagScope =
        Boolean(algolia.sheetMusicEnforceTagScope) &&
        Array.isArray(algolia.sheetMusicTagScope) &&
        algolia.sheetMusicTagScope.length > 0;

      if (shouldApplySheetMusicTagScope) {
        var tagScopeFilter = buildSheetMusicTagScopeFilter(
          algolia.sheetMusicTagScope
        );

        if (tagScopeFilter) {
          collectionFacetFilter = collectionFacetFilter
            ? '(' + collectionFacetFilter + ') AND ' + tagScopeFilter
            : tagScopeFilter;
        }
      }
    } else {
      if (algolia.config.collection_id_indexing) {
        collectionFacetFilter = algolia.current_collection_id
          ? 'collection_ids:"' + algolia.current_collection_id + '"'
          : null;
      } else {
        collectionFacetFilter = 'collections:"' + collectionHandle + '"';
      }
    }

    // Add the collection filter to the list of search filters
    if (collectionFacetFilter) {
      searchFilters.push(collectionFacetFilter);
    }

    if (!isSheetMusicCollection) {
      collectionRulesContextValue = algolia.config.collection_id_query_rules
        ? algolia.current_collection_id
        : collectionHandle;
    }
  }

  if (
    isSheetMusicStandalonePage
  ) {
    var standaloneMasterCollectionFilter = buildSheetMusicMasterCollectionFilter();

    if (standaloneMasterCollectionFilter) {
      searchFilters.push(standaloneMasterCollectionFilter);
    } else if (
      Boolean(algolia.sheetMusicEnforceTagScope) &&
      Array.isArray(algolia.sheetMusicTagScope) &&
      algolia.sheetMusicTagScope.length > 0
    ) {
      var standaloneTagScopeFilter = buildSheetMusicTagScopeFilter(
        algolia.sheetMusicTagScope
      );

      if (standaloneTagScopeFilter) {
        searchFilters.push(standaloneTagScopeFilter);
      }
    }

    if (sheetMusicCollectionScope && sheetMusicCollectionScope.filter) {
      searchFilters.push(sheetMusicCollectionScope.filter);
    }
  }

  isSheetMusicExperience = isSheetMusicCollection || isSheetMusicStandalonePage;

  var localFacetSearchFacets =
    isSheetMusicExperience && Array.isArray(algolia.localFacetSearchAttributes)
      ? algolia.localFacetSearchAttributes.filter(function(attribute) {
          return instantFacetsContainAttribute(attribute);
        })
      : [];
  var SHEET_MUSIC_EXACT_ATTRS = ['title', 'meta.next_cart.composer'];
  var sheetMusicExactToggleStorageKey = 'cnmc_sheet_music_exact_search_mode';
  var sheetMusicExactMode = false;

  var parseSheetMusicExactModeToken = function(value) {
    if (value === null || typeof value === 'undefined') {
      return null;
    }

    var normalizedValue = String(value).toLowerCase().trim();
    if (
      normalizedValue === '1' ||
      normalizedValue === 'true' ||
      normalizedValue === 'yes' ||
      normalizedValue === 'on'
    ) {
      return true;
    }

    if (
      normalizedValue === '0' ||
      normalizedValue === 'false' ||
      normalizedValue === 'no' ||
      normalizedValue === 'off'
    ) {
      return false;
    }

    return null;
  };

  var readInitialSheetMusicExactMode = function() {
    if (!isSheetMusicExperience) {
      return false;
    }

    var modeFromQuery = null;
    try {
      if (window.URLSearchParams) {
        var params = new URLSearchParams(window.location.search || '');
        modeFromQuery = parseSheetMusicExactModeToken(params.get('exact'));
      }
    } catch (error) {
      modeFromQuery = null;
    }

    if (modeFromQuery !== null) {
      return modeFromQuery;
    }

    try {
      var storedValue = window.localStorage
        ? window.localStorage.getItem(sheetMusicExactToggleStorageKey)
        : null;
      var modeFromStorage = parseSheetMusicExactModeToken(storedValue);

      return modeFromStorage === null ? false : modeFromStorage;
    } catch (error) {
      return false;
    }
  };

  sheetMusicExactMode = readInitialSheetMusicExactMode();

  function instantFacetsContainAttribute(attribute) {
    var list =
      collectionPageEnabled && algolia.collectionFacets
        ? algolia.collectionFacets
        : algolia.facets || [];

    return list.some(function(facet) {
      return facet.name === attribute;
    });
  }

  // Filters for stock policy
  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
      /**
       * For 'allow', we don't need to add any filter as we want to continue
       * displaying all out of stock items.
       */
    } else if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = '(inventory_quantity > 0 OR tags:"cnmc-sold" OR tags:"cnmc-sale-pending")';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }

    // Add the stock policy filter to the list of search filters
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }

  var resolveExistingSelector = function(candidates) {
    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];

      if (!candidate) {
        continue;
      }

      if (document.querySelectorAll(candidate).length > 0) {
        return candidate;
      }
    }

    return null;
  };

  var selectorCandidates = collectionPageEnabled
    ? [algolia.config.collection_css_selector, '#main', '#MainContent', 'main']
    : [algolia.config.results_selector, '#main', '#MainContent', 'main'];

  var resolvedRootSelector = resolveExistingSelector(selectorCandidates);

  if (collectionPageEnabled && resolvedRootSelector) {
    algolia.config.collection_css_selector = resolvedRootSelector;
  }

  if (!collectionPageEnabled && resolvedRootSelector) {
    algolia.config.results_selector = resolvedRootSelector;
  }

  var results_selector = resolvedRootSelector ||
    (collectionPageEnabled
      ? algolia.config.collection_css_selector
      : algolia.config.results_selector);

  var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function(k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'collection',
    'collection_id',
    'collection_label',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function(uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function(routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function(acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    hitsPerPage:
      collectionPageEnabled &&
      algolia.config.collections_full_results_hits_per_page
        ? algolia.config.collections_full_results_hits_per_page
        : algolia.config.products_full_results_hits_per_page,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: algolia.config.analytics_enabled,
      indexName: algolia.config.index_prefix + 'products' + index_suffix,
      routing: {
        stateMapping: singleIndex(algolia.config.index_prefix + 'products' + index_suffix),
      },
      searchFunction: function(searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }

        // Assign any required filters
        if (searchFilters.length) {
          searchFunctionHelper.setQueryParameter(
            'filters',
            searchFilters.join(' AND ')
          );
        }

        // Assign any required `ruleContexts` which are required for query rules
        // targeting collection pages
        if (collectionPageEnabled) {
          // Collection page merchandising:
          // If we are on a collection page, `collectionRulesContextValue` is defined
          if (collectionRulesContextValue) {
            searchFunctionHelper.setQueryParameter('ruleContexts', [
              collectionRulesContextValue.toString(),
            ]);
          } else {
            searchFunctionHelper.setQueryParameter('ruleContexts', []);
          }
        }

        if (isSheetMusicExperience && sheetMusicExactMode) {
          searchFunctionHelper.setQueryParameter(
            'restrictSearchableAttributes',
            SHEET_MUSIC_EXACT_ATTRS
          );
          searchFunctionHelper.setQueryParameter('removeWordsIfNoResults', 'none');
          searchFunctionHelper.setQueryParameter('typoTolerance', 'min');
        } else {
          searchFunctionHelper.setQueryParameter(
            'restrictSearchableAttributes',
            undefined
          );
          searchFunctionHelper.setQueryParameter('removeWordsIfNoResults', undefined);
          searchFunctionHelper.setQueryParameter('typoTolerance', undefined);
        }

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
    selector: results_selector + ', .algolia-shopify-instantsearch',
    sortOrders: activeSortOrders
  };
  
  instant.search.client.addAlgoliaAgent('Shopify Integration');

  algolia.instantsearch = instant;


  function readjust() {
    var width = instant.$results.offsetWidth;

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }


  //Link CSS and set up CSS variables
  const cssFile = document.getElementById('template_algolia_instant_search.css');
  document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
  document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
  document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  algolia.appendStyle(cssFile.text);

  if (!results_selector || document.querySelectorAll(results_selector).length === 0) {
    if (collectionPageEnabled) {
      throw new Error(
        'Instant search CSS selector for collection page is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/advanced-customization/collection-search-page/#css-selector'
      );
    }

    throw new Error(
      'Instant search CSS selector is incorrect\nFor more info see: https://www.algolia.com/doc/integration/shopify/building-search-ui/instant-search/#css-selector'
    );
  }

  // Instantiating the main page
  instant.$results = document.querySelector(instant.selector);
  instant.$results.innerHTML = '';

  var normalizeLegacySheetMusicTemplate = function() {
    if (!isSheetMusicExperience || !instant.$results) {
      return;
    }

    var facetsRoot = instant.$results.querySelector('.ais-facets');
    if (!facetsRoot) {
      return;
    }

    // Legacy template versions place current/clear containers inside the grid.
    // Move them into a dedicated row to avoid consuming facet grid columns.
    var existingMetaRow = instant.$results.querySelector('.ais-facets-meta');
    if (!existingMetaRow) {
      var currentContainer = facetsRoot.querySelector(
        '.ais-current-refined-values-container'
      );
      var clearContainer = facetsRoot.querySelector(
        '.ais-clear-refinements-container'
      );

      if (currentContainer || clearContainer) {
        existingMetaRow = document.createElement('div');
        existingMetaRow.className = 'ais-facets-meta';

        if (currentContainer) {
          existingMetaRow.appendChild(currentContainer);
        }
        if (clearContainer) {
          existingMetaRow.appendChild(clearContainer);
        }

        if (facetsRoot.parentNode) {
          facetsRoot.parentNode.insertBefore(existingMetaRow, facetsRoot);
        }
      }
    }

    Array.prototype.slice
      .call(facetsRoot.querySelectorAll('.ais-facet-dropdown-wrapper'))
      .forEach(function(wrapper) {
        var checkbox = wrapper.querySelector('.ais-dropdown-checkbox');
        var header = wrapper.querySelector('.ais-facet--header');

        if (checkbox && header && header.previousElementSibling !== checkbox) {
          wrapper.insertBefore(checkbox, header);
        }

        if (header && !header.querySelector('.ais-facet-dropdown-title')) {
          var title = document.createElement('span');
          title.className = 'ais-facet-dropdown-title';
          title.textContent = (header.textContent || '').trim();

          var toggle = document.createElement('span');
          toggle.className = 'ais-facet-dropdown-toggle';
          toggle.setAttribute('aria-hidden', 'true');

          header.textContent = '';
          header.appendChild(title);
          header.appendChild(toggle);
        }
      });
  };

  var buildSheetMusicScopeClearUrl = function(clearAll) {
    var url = new URL(window.location.href);
    var preservedCampaignParams = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ];

    if (clearAll) {
      var campaignValues = {};
      preservedCampaignParams.forEach(function(key) {
        if (url.searchParams.has(key)) {
          campaignValues[key] = url.searchParams.get(key);
        }
      });
      url.search = '';
      Object.keys(campaignValues).forEach(function(key) {
        url.searchParams.set(key, campaignValues[key]);
      });
    } else {
      url.searchParams.delete('collection');
      url.searchParams.delete('collection_id');
      url.searchParams.delete('collection_label');
    }

    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams : '');
  };

  var ensureSheetMusicCollectionScopeControl = function() {
    if (!sheetMusicCollectionScope || !instant.$results) {
      return;
    }

    var metaRow = instant.$results.querySelector('.ais-facets-meta');
    if (!metaRow || metaRow.querySelector('.ais-sheet-collection-scope')) {
      return;
    }

    var scope = document.createElement('div');
    scope.className = 'ais-sheet-collection-scope';
    scope.setAttribute('aria-label', 'Collection filter');

    var prefix = document.createElement('span');
    prefix.className = 'ais-sheet-collection-scope__prefix';
    prefix.textContent = 'Browsing:';

    var clearLink = document.createElement('a');
    clearLink.className = 'ais-sheet-collection-scope__clear';
    clearLink.href = buildSheetMusicScopeClearUrl(false);
    clearLink.setAttribute(
      'aria-label',
      'Clear collection filter: ' + sheetMusicCollectionScope.label
    );

    var label = document.createElement('span');
    label.className = 'ais-sheet-collection-scope__label';
    label.textContent = sheetMusicCollectionScope.label;

    var close = document.createElement('span');
    close.className = 'ais-sheet-collection-scope__x';
    close.setAttribute('aria-hidden', 'true');
    close.textContent = '×';

    clearLink.appendChild(label);
    clearLink.appendChild(close);
    scope.appendChild(prefix);
    scope.appendChild(clearLink);
    metaRow.insertBefore(scope, metaRow.firstChild);

    instant.$results.addEventListener(
      'click',
      function(event) {
        var target = event.target;
        var clearAllControl =
          target && target.closest
            ? target.closest(
                '.ais-clear-refinements-container button, .ais-clear-refinements-container a'
              )
            : null;
        if (!clearAllControl) {
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(buildSheetMusicScopeClearUrl(true));
      },
      true
    );
  };

  var collapseSheetMusicFacetPanelsOnLoad = function() {
    if (!isSheetMusicExperience || !instant.$results) {
      return;
    }

    Array.prototype.slice
      .call(
        instant.$results.querySelectorAll(
          '.ais-facet-dropdown-wrapper .ais-dropdown-checkbox'
        )
      )
      .forEach(function(checkbox) {
        if (checkbox.dataset.sheetMusicInitStateApplied === 'true') {
          return;
        }

        checkbox.checked = true;
        checkbox.dataset.sheetMusicInitStateApplied = 'true';
      });
  };

  var ensureSheetMusicHitsPerPageControl = function() {
    if (!isSheetMusicExperience || !instant.$results) {
      return null;
    }

    var container = instant.$results.querySelector('.ais-hits-per-page-container');
    if (container) {
      return container;
    }

    var searchHeader = instant.$results.querySelector('.ais-search-header');
    if (!searchHeader) {
      return null;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'ais-hits-per-page';

    var label = document.createElement('span');
    label.className = 'ais-hits-per-page-label';
    label.textContent = 'Show';

    container = document.createElement('span');
    container.className = 'ais-hits-per-page-container';

    wrapper.appendChild(label);
    wrapper.appendChild(container);

    var sortNode = searchHeader.querySelector('.ais-sort');
    if (sortNode) {
      searchHeader.insertBefore(wrapper, sortNode);
    } else {
      searchHeader.appendChild(wrapper);
    }

    return container;
  };

  var ensureSheetMusicExactToggleStyles = function() {
    if (document.getElementById('ais-sheet-exact-toggle-style')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'ais-sheet-exact-toggle-style';
    style.textContent =
      '@media (min-width:1000px){' +
      '.ais-page--sheet-music{margin-top:0 !important;column-gap:24px !important;row-gap:6px !important;}' +
      '.ais-page--sheet-music>.ais-h2{grid-column:1 !important;margin:0 !important;align-self:start !important;font-size:2rem !important;line-height:1.1 !important;}' +
      '.ais-page--sheet-music>.ais-sheet-music-intro{grid-column:1 !important;margin:0 !important;padding:8px 10px !important;align-self:start !important;background:linear-gradient(180deg, rgba(250, 249, 246, 0.95), rgba(245, 242, 236, 0.92)) !important;border:1px solid rgba(64, 53, 39, 0.08) !important;border-radius:14px !important;box-shadow:0 8px 18px rgba(33, 28, 21, 0.04) !important;}' +
      '.ais-page--sheet-music>.ais-input,.ais-page--sheet-music>.ais-sheet-exact-toggle,.ais-page--sheet-music>.ais-sheet-music-shortcuts,.ais-page--sheet-music>.ais-sheet-preview-controls,.ais-page--sheet-music>.ais-facets-meta,.ais-page--sheet-music>.ais-pagination-container{grid-column:2/3 !important;}' +
      '.ais-page--sheet-music>.ais-input{align-self:start !important;margin:0 0 6px !important;max-width:none !important;width:100% !important;}' +
      '.ais-page--sheet-music .ais-input{margin-bottom:6px !important;}' +
      '.ais-page--sheet-music .ais-sheet-exact-toggle,.ais-page--sheet-music .ais-sheet-music-shortcuts{grid-column:2/3 !important;justify-self:center !important;}' +
      '}' +
      '@media (max-width:999px){' +
      '.ais-page--sheet-music .ais-input{margin:0 auto 16px !important;}' +
      '.ais-page--sheet-music .ais-sheet-exact-toggle,.ais-page--sheet-music .ais-sheet-music-shortcuts{grid-column:1/-1 !important;justify-self:center !important;}' +
      '}' +
      '.ais-page--sheet-music .ais-sheet-music-shortcuts{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:10px 12px;text-align:center;margin-top:4px;margin-bottom:6px;}' +
      '.ais-page--sheet-music .ais-sheet-music-shortcuts .ais-sheet-filter-chip{margin:0;}' +
      '.ais-page--sheet-music .ais-SearchBox-form{margin-top:0 !important;}' +
      '.ais-page--sheet-music .ais-search-header{margin-top:8px !important;padding:0 !important;gap:10px !important;}' +
      '.ais-sheet-exact-toggle{margin:0 auto;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;gap:4px;width:100%;float:none !important;}' +
      '.ais-sheet-exact-toggle__label{display:inline-flex;align-items:center;justify-content:center;gap:10px;cursor:pointer;font-size:13px;letter-spacing:.08em;text-transform:uppercase;color:#1c1c1c;}' +
      '.ais-sheet-exact-toggle__input{width:16px;height:16px;cursor:pointer;}' +
      '.ais-sheet-exact-toggle__hint{font-size:11px;line-height:1.35;color:#555;max-width:860px;padding:0 8px;}' +
      '.ais-sheet-exact-toggle__mode{font-weight:600;}';
    document.head.appendChild(style);
  };

  var getLargestVisibleWidth = function(root, selectors) {
    if (!root || !selectors || !selectors.length) {
      return 0;
    }

    var maxWidth = 0;

    selectors.forEach(function(selector) {
      var nodes = root.querySelectorAll(selector);

      Array.prototype.slice.call(nodes).forEach(function(node) {
        if (!node || !node.getBoundingClientRect) {
          return;
        }

        var rect = node.getBoundingClientRect();
        if (!rect || rect.width <= 0 || rect.height <= 0) {
          return;
        }

        var computed = window.getComputedStyle(node);
        if (!computed) {
          return;
        }

        if (computed.display === 'none' || computed.visibility === 'hidden') {
          return;
        }

        if (rect.width > maxWidth) {
          maxWidth = rect.width;
        }
      });
    });

    return Math.round(maxWidth);
  };

  var applySheetMusicTopControlBaseStyles = function(node) {
    if (!node || !node.style) {
      return;
    }

    var isDesktopSheetMusicLayout = window.matchMedia('(min-width: 1000px)').matches;

    node.style.gridColumn = isDesktopSheetMusicLayout ? '2 / 3' : '1 / -1';
    node.style.justifySelf = 'center';
    node.style.marginLeft = 'auto';
    node.style.marginRight = 'auto';
    node.style.textAlign = 'center';

    if (node.classList.contains('ais-sheet-exact-toggle')) {
      node.style.display = 'flex';
      node.style.flexDirection = 'column';
      node.style.alignItems = 'center';
      node.style.justifyContent = 'center';
      node.style.gap = '6px';
      node.style.marginTop = '2px';
      node.style.marginBottom = '0px';
      node.style.float = 'none';
    }

    if (node.classList.contains('ais-sheet-music-shortcuts')) {
      node.style.display = 'flex';
      node.style.flexWrap = 'wrap';
      node.style.justifyContent = 'center';
      node.style.alignItems = 'center';
      node.style.gap = '10px 12px';
      node.style.marginTop = '6px';
      node.style.marginBottom = '12px';
    }
  };

  var syncSheetMusicTopControlsAlignment = function() {
    if (!isSheetMusicExperience || !instant.$results) {
      return;
    }

    var inputRow = instant.$results.querySelector('.ais-input');
    if (inputRow && inputRow.style) {
      inputRow.style.marginBottom = window.matchMedia('(min-width: 1000px)').matches
        ? '14px'
        : '24px';
    }

    var targets = [
      instant.$results.querySelector('.ais-sheet-exact-toggle'),
      instant.$results.querySelector('.ais-sheet-music-shortcuts'),
    ];

    targets.forEach(function(node) {
      if (!node) {
        return;
      }

      applySheetMusicTopControlBaseStyles(node);
    });

    var targetWidth = getLargestVisibleWidth(instant.$results, [
      '.ais-input',
      '.ais-search-box-container',
      '.ais-search-box--input',
      '.ais-SearchBox-input',
      '.ais-SearchBox-form',
    ]);

    ensureSheetMusicDesktopTopLayout();
    positionSheetMusicIntroCard();
    positionSheetMusicPreviewControls();

    if (!targetWidth || targetWidth < 220) {
      return;
    }

    targets.forEach(function(node) {
      if (!node) {
        return;
      }

      node.style.width = targetWidth + 'px';
      node.style.maxWidth = targetWidth + 'px';
    });
  };

  var positionSheetMusicPreviewControls = function() {
    if (!isSheetMusicExperience || !instant.$results) {
      return;
    }

    var previewControls = instant.$results.querySelector(
      '.ais-sheet-preview-controls'
    );
    if (!previewControls) {
      return;
    }

    var isDesktopSheetMusicLayout = window.matchMedia('(min-width: 1000px)')
      .matches;
    var searchHeader = instant.$results.querySelector(
      '.ais-page--sheet-music .ais-search-header'
    );
    var shortcuts = instant.$results.querySelector('.ais-sheet-music-shortcuts');
    var exactToggle = instant.$results.querySelector('.ais-sheet-exact-toggle');
    var inputRow = instant.$results.querySelector('.ais-input');

    if (isDesktopSheetMusicLayout && searchHeader) {
      previewControls.classList.add('ais-sheet-preview-controls--header');
      var referenceNode =
        searchHeader.querySelector('.ais-hits-per-page') ||
        searchHeader.querySelector('.ais-sort');

      if (referenceNode) {
        if (
          previewControls.parentNode !== searchHeader ||
          previewControls.nextSibling !== referenceNode
        ) {
          searchHeader.insertBefore(previewControls, referenceNode);
        }
      } else if (previewControls.parentNode !== searchHeader) {
        searchHeader.appendChild(previewControls);
      }
      return;
    }

    previewControls.classList.remove('ais-sheet-preview-controls--header');
    var anchor = shortcuts || exactToggle || inputRow;
    if (!anchor || !anchor.parentNode) {
      return;
    }

    if (anchor.nextSibling) {
      if (
        previewControls.parentNode !== anchor.parentNode ||
        previewControls.previousSibling !== anchor
      ) {
        anchor.parentNode.insertBefore(previewControls, anchor.nextSibling);
      }
    } else if (previewControls.parentNode !== anchor.parentNode) {
      anchor.parentNode.appendChild(previewControls);
    }
  };

  var positionSheetMusicIntroCard = function() {
    if (!isSheetMusicExperience || !instant.$results) {
      return;
    }

    var pageRoot = instant.$results.querySelector('.ais-page--sheet-music');
    var intro = instant.$results.querySelector('.ais-sheet-music-intro');
    var heading = instant.$results.querySelector('.ais-page--sheet-music > .ais-h2');
    var facets = instant.$results.querySelector('.ais-page--sheet-music > .ais-facets');

    if (!pageRoot || !intro || !heading) {
      return;
    }

    var isDesktopSheetMusicLayout = window.matchMedia('(min-width: 1000px)')
      .matches;

    if (isDesktopSheetMusicLayout && facets) {
      intro.classList.add('ais-sheet-music-intro--in-facets');
      if (intro.parentNode !== facets || intro !== facets.firstElementChild) {
        facets.insertBefore(intro, facets.firstChild);
      }
      return;
    }

    intro.classList.remove('ais-sheet-music-intro--in-facets');
    if (intro.parentNode !== pageRoot || heading.nextElementSibling !== intro) {
      pageRoot.insertBefore(intro, heading.nextSibling);
    }
  };

  var ensureSheetMusicDesktopTopLayout = function() {
    if (!isSheetMusicExperience || !instant.$results) {
      return;
    }

    var isDesktopSheetMusicLayout = window.matchMedia('(min-width: 1000px)')
      .matches;
    var inputRow = instant.$results.querySelector('.ais-page--sheet-music > .ais-input');
    var exactToggle = instant.$results.querySelector(
      '.ais-page--sheet-music > .ais-sheet-exact-toggle'
    );
    var shortcuts = instant.$results.querySelector(
      '.ais-page--sheet-music > .ais-sheet-music-shortcuts'
    );

    if (!isDesktopSheetMusicLayout) {
      [inputRow, exactToggle, shortcuts].forEach(function(node) {
        if (!node || !node.style) {
          return;
        }
        node.style.alignSelf = '';
        node.style.marginTop = '';
      });
      return;
    }

    if (inputRow && inputRow.style) {
      inputRow.style.alignSelf = 'start';
      inputRow.style.marginTop = '0';
    }

    if (exactToggle && exactToggle.style) {
      exactToggle.style.alignSelf = 'start';
      exactToggle.style.marginTop = '0';
    }

    if (shortcuts && shortcuts.style) {
      shortcuts.style.alignSelf = 'start';
      shortcuts.style.marginTop = '0';
    }
  };

  var syncSheetMusicIntroVisibility = function() {
    if (!isSheetMusicExperience || !instant.$results) {
      return;
    }

    var pageRoot = instant.$results.querySelector('.ais-page--sheet-music');
    if (!pageRoot) {
      return;
    }

    pageRoot.classList.remove('ais-page--sheet-music-intro-hidden');
  };

  var bindSheetMusicIntroVisibility = function() {
    syncSheetMusicIntroVisibility();
  };

  var syncSheetMusicExactToggleUi = function() {
    if (!instant.$results) {
      return;
    }

    var input = instant.$results.querySelector('.ais-sheet-exact-toggle__input');
    var mode = instant.$results.querySelector('.ais-sheet-exact-toggle__mode');

    if (input) {
      input.checked = Boolean(sheetMusicExactMode);
    }

    if (mode) {
      mode.textContent = sheetMusicExactMode ? 'On' : 'Off';
    }
  };

  var updateSheetMusicExactModeUrl = function() {
    try {
      if (!window.history || !window.history.replaceState || !window.URL) {
        return;
      }

      var url = new URL(window.location.href);
      if (sheetMusicExactMode) {
        url.searchParams.set('exact', '1');
      } else {
        url.searchParams.delete('exact');
      }
      window.history.replaceState({}, '', url.toString());
    } catch (error) {}
  };

  var ensureSheetMusicExactToggleControl = function(helper) {
    if (!isSheetMusicExperience || !instant.$results) {
      return;
    }

    var introRoot = instant.$results.querySelector('.ais-sheet-music-intro');
    var searchInputRow = instant.$results.querySelector('.ais-input');

    if (!introRoot || !searchInputRow) {
      return;
    }

    ensureSheetMusicExactToggleStyles();

    var wrapper = instant.$results.querySelector('.ais-sheet-exact-toggle');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'ais-sheet-exact-toggle';

      var label = document.createElement('label');
      label.className = 'ais-sheet-exact-toggle__label';

      var input = document.createElement('input');
      input.type = 'checkbox';
      input.className = 'ais-sheet-exact-toggle__input';
      input.setAttribute('aria-label', 'Known title or composer mode');

      var labelText = document.createElement('span');
      labelText.textContent = 'Known title/composer';

      label.appendChild(input);
      label.appendChild(labelText);

      var hint = document.createElement('div');
      hint.className = 'ais-sheet-exact-toggle__hint';
      hint.innerHTML =
        'Mode: <span class="ais-sheet-exact-toggle__mode">Off</span>. ' +
        'Best when you know the exact piece or composer and want the cleanest match.';

      input.addEventListener('change', function(event) {
        sheetMusicExactMode = Boolean(event.currentTarget.checked);

        try {
          if (window.localStorage) {
            window.localStorage.setItem(
              sheetMusicExactToggleStorageKey,
              sheetMusicExactMode ? '1' : '0'
            );
          }
        } catch (error) {}

        updateSheetMusicExactModeUrl();
        syncSheetMusicExactToggleUi();

        if (helper) {
          helper.setPage(0);
          helper.search();
        }
      });

      wrapper.appendChild(label);
      wrapper.appendChild(hint);
    }

    if (wrapper.parentNode !== introRoot) {
      if (wrapper.parentNode) {
        wrapper.parentNode.removeChild(wrapper);
      }
      introRoot.appendChild(wrapper);
    }

    if (searchInputRow.parentNode && searchInputRow.nextSibling !== wrapper) {
      if (wrapper.parentNode) {
        wrapper.parentNode.removeChild(wrapper);
      }

      if (searchInputRow.nextSibling) {
        searchInputRow.parentNode.insertBefore(wrapper, searchInputRow.nextSibling);
      } else {
        searchInputRow.parentNode.appendChild(wrapper);
      }
    }

    syncSheetMusicTopControlsAlignment();
    syncSheetMusicExactToggleUi();
  };

  algolia.render(algolia.instantSearchMainTemplate, instant.$results, {
    facets: instant.facets.list,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  normalizeLegacySheetMusicTemplate();
  ensureSheetMusicCollectionScopeControl();
  collapseSheetMusicFacetPanelsOnLoad();

  if (isSheetMusicExperience) {
    var introLead = instant.$results.querySelector('.ais-sheet-music-intro__lead');
    var introHowTo = instant.$results.querySelector('.ais-sheet-music-intro__howto');

    if (introLead) {
      introLead.textContent =
        'Sheet Music Search is the fastest way to narrow the catalog when you know a title, composer, instrumentation, or category.';
    }

    if (introHowTo) {
      introHowTo.textContent =
        'Type a title or composer, use the starting-point buttons for common setups, and open filters for instrumentation, category, publisher, genre, and price. If you already know the exact piece or composer, turn on Known title/composer.';
    }
  }

  var sheetMusicHitsPerPageContainer = ensureSheetMusicHitsPerPageControl();

  readjust();
  syncSheetMusicTopControlsAlignment();

  if (isSheetMusicExperience) {
    [0, 150, 400, 1000, 2000].forEach(function(delay) {
      window.setTimeout(syncSheetMusicTopControlsAlignment, delay);
    });
  }

  window.addEventListener('resize', function() {
    readjust();
    syncSheetMusicTopControlsAlignment();
  });

  // Mobile facets display
  instant.search.addWidgets([
    {
      init: function() {
        var $button = document.querySelector('.ais-facets-button');
        var $facets = document.querySelector('.ais-facets');

        if (!$button || !$facets) {
          return;
        }
        var $buttonLabel = $button.querySelector('.ais-facets-button__label');
        var $buttonCount = $button.querySelector('.ais-facets-button__count');
        var $close = $facets.querySelector('.ais-facets-sheet__close');
        var $apply = $facets.querySelector('.ais-facets-sheet__apply');
        var mobileMedia = window.matchMedia('(max-width: 699px)');
        var $backdrop = document.createElement('button');
        $backdrop.type = 'button';
        $backdrop.className = 'ais-facets-sheet__backdrop';
        $backdrop.setAttribute('aria-label', 'Close filters');
        document.body.appendChild($backdrop);

        function activeFilterCount() {
          var current = document.querySelector('.ais-facets-meta .ais-current-refined-values-container');
          return current ? current.querySelectorAll('.ais-current-refined-values--link').length : 0;
        }

        function updateButton() {
          var count = activeFilterCount();
          if ($buttonLabel) $buttonLabel.textContent = 'Filters';
          if ($buttonCount) {
            $buttonCount.textContent = count ? String(count) : '';
            $buttonCount.hidden = !count;
          }
          if ($apply) $apply.textContent = count ? 'Show filtered results' : 'Show all results';
        }

        function setOpen(open) {
          var mobileOpen = Boolean(open && mobileMedia.matches);
          $facets.classList.toggle('ais-facets__shown', mobileOpen || !mobileMedia.matches);
          $facets.classList.toggle('ais-facets__sheet-open', mobileOpen);
          $backdrop.classList.toggle('is-visible', mobileOpen);
          document.body.classList.toggle('ais-facets-sheet-open', mobileOpen);
          $button.setAttribute('aria-expanded', mobileOpen ? 'true' : 'false');
          if (mobileOpen && $close) $close.focus();
          updateButton();
        }

        $button.addEventListener('click', function() {
          setOpen(!$facets.classList.contains('ais-facets__sheet-open'));
        });
        if ($close) $close.addEventListener('click', function() { setOpen(false); });
        if ($apply) $apply.addEventListener('click', function() { setOpen(false); });
        $backdrop.addEventListener('click', function() { setOpen(false); });
        document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape' && $facets.classList.contains('ais-facets__sheet-open')) {
            setOpen(false);
            $button.focus();
          }
        });
        if (mobileMedia.addEventListener) {
          mobileMedia.addEventListener('change', function() { setOpen(false); });
        } else if (mobileMedia.addListener) {
          mobileMedia.addListener(function() { setOpen(false); });
        }

        setOpen(false);
      },
      render: function() {
        var $count = document.querySelector('.ais-facets-button__count');
        var current = document.querySelector('.ais-facets-meta .ais-current-refined-values-container');
        var count = current ? current.querySelectorAll('.ais-current-refined-values--link').length : 0;
        if ($count) {
          $count.textContent = count ? String(count) : '';
          $count.hidden = !count;
        }
      },
    },
  ]);

  var configureParams = {
    hitsPerPage: instant.hitsPerPage,
    facetingAfterDistinct: Boolean(algolia.config.show_products),
  };

  if (isSheetMusicExperience) {
    configureParams.maxValuesPerFacet = 3000;
  }

  instant.search.addWidgets([configure(configureParams)]);

  // Search input
  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      placeholder: isSheetMusicExperience
        ? 'Search by title, composer, instrumentation, or category'
        : algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
    }),
  ]);

  if (isSheetMusicExperience) {
    instant.search.addWidgets([
      {
        init: function(opts) {
          bindSheetMusicIntroVisibility();
        },
        render: function(opts) {
          bindSheetMusicIntroVisibility();
          syncSheetMusicIntroVisibility();
        },
      },
    ]);
  }

  if (isSheetMusicExperience) {
    instant.search.addWidgets([
      {
        init: function(opts) {
          ensureSheetMusicExactToggleControl(opts.helper);
          syncSheetMusicTopControlsAlignment();
        },
        render: function(opts) {
          ensureSheetMusicExactToggleControl(opts.helper);
          syncSheetMusicTopControlsAlignment();
        },
      },
    ]);
  }

  if (isSheetMusicExperience && sheetMusicHitsPerPageContainer) {
    var sheetMusicMinimumHitsPerPage = 12;
    var sheetMusicHitsPerPageOptions = [12, 24, 48, 96];

    instant.search.addWidgets([
      {
        init: function(opts) {
          if (!sheetMusicHitsPerPageContainer) {
            return;
          }

          var helperHitsPerPage = null;
          if (
            opts.helper &&
            opts.helper.state &&
            typeof opts.helper.state.getQueryParameter === 'function'
          ) {
            helperHitsPerPage = parseInt(
              opts.helper.state.getQueryParameter('hitsPerPage'),
              10
            );
          }

          if (
            isNaN(helperHitsPerPage) ||
            helperHitsPerPage < sheetMusicMinimumHitsPerPage
          ) {
            opts.helper.setQueryParameter(
              'hitsPerPage',
              sheetMusicMinimumHitsPerPage
            );
            opts.helper.setPage(0);
            opts.helper.search();
          }

          sheetMusicHitsPerPageContainer.innerHTML = '';

          var select = document.createElement('select');
          select.className = 'ais-hits-per-page-select';

          sheetMusicHitsPerPageOptions.forEach(function(optionValue) {
            var option = document.createElement('option');
            option.value = String(optionValue);
            option.textContent = String(optionValue);
            select.appendChild(option);
          });

          select.addEventListener('change', function(event) {
            var parsedValue = parseInt(event.currentTarget.value, 10);

            if (isNaN(parsedValue) || parsedValue <= 0) {
              return;
            }

            opts.helper.setQueryParameter('hitsPerPage', parsedValue);
            opts.helper.setPage(0);
            opts.helper.search();
          });

          sheetMusicHitsPerPageContainer.appendChild(select);
        },
        render: function(opts) {
          if (!sheetMusicHitsPerPageContainer) {
            return;
          }

          var select = sheetMusicHitsPerPageContainer.querySelector('select');
          if (!select) {
            return;
          }

          var currentHitsPerPageRaw = null;

          if (
            opts.helper &&
            opts.helper.state &&
            typeof opts.helper.state.getQueryParameter === 'function'
          ) {
            currentHitsPerPageRaw = opts.helper.state.getQueryParameter(
              'hitsPerPage'
            );
          } else if (opts.state && opts.state.hitsPerPage) {
            currentHitsPerPageRaw = opts.state.hitsPerPage;
          }

          var currentHitsPerPage = parseInt(currentHitsPerPageRaw, 10);
          if (isNaN(currentHitsPerPage) || currentHitsPerPage <= 0) {
            currentHitsPerPage = instant.hitsPerPage;
          }

          if (sheetMusicHitsPerPageOptions.indexOf(currentHitsPerPage) === -1) {
            currentHitsPerPage = sheetMusicHitsPerPageOptions[0];
          }

          select.value = String(currentHitsPerPage);
        },
      },
    ]);
  }

  if (
    isSheetMusicExperience &&
    Array.isArray(algolia.sheetMusicQuickFilters) &&
    algolia.sheetMusicQuickFilters.length > 0
  ) {
    var quickFilterFacetTypeByName = instant.facets.list.reduce(function(acc, facet) {
      if (facet && facet.name && facet.type) {
        acc[facet.name] = facet.type;
      }

      return acc;
    }, {});

    var getQuickFilterFacetType = function(facetName, state) {
      if (!facetName) {
        return null;
      }

      if (facetName === 'tags') {
        return 'tag';
      }

      var configuredType = quickFilterFacetTypeByName[facetName];

      if (configuredType === 'disjunctive' || configuredType === 'conjunctive') {
        return configuredType;
      }

      if (
        state &&
        typeof state.isDisjunctiveFacet === 'function' &&
        state.isDisjunctiveFacet(facetName)
      ) {
        return 'disjunctive';
      }

      if (
        state &&
        typeof state.isConjunctiveFacet === 'function' &&
        state.isConjunctiveFacet(facetName)
      ) {
        return 'conjunctive';
      }

      return null;
    };

    var toggleSheetMusicQuickFilterRefinement = function(helper, facet, value) {
      if (!helper || !facet || !value) {
        return false;
      }

      var state = helper.state || null;
      var facetType = getQuickFilterFacetType(facet, state);

      if (facetType === 'tag' && typeof helper.toggleTag === 'function') {
        helper.toggleTag(value);
        return true;
      }

      if (facetType === 'conjunctive' && typeof helper.toggleFacetRefinement === 'function') {
        helper.toggleFacetRefinement(facet, value);
        return true;
      }

      if (typeof helper.toggleDisjunctiveFacetRefinement === 'function') {
        helper.toggleDisjunctiveFacetRefinement(facet, value);
        return true;
      }

      if (typeof helper.toggleFacetRefinement === 'function') {
        helper.toggleFacetRefinement(facet, value);
        return true;
      }

      return false;
    };

    var isQuickFilterRefined = function(state, facet, value) {
      if (!state || !facet || !value) {
        return false;
      }

      if (facet === 'tags' && typeof state.isTagRefined === 'function') {
        return state.isTagRefined(value);
      }

      var facetType = getQuickFilterFacetType(facet, state);

      if (
        facetType === 'disjunctive' &&
        typeof state.isDisjunctiveFacetRefined === 'function'
      ) {
        return state.isDisjunctiveFacetRefined(facet, value);
      }

      if (facetType === 'conjunctive' && typeof state.isFacetRefined === 'function') {
        return state.isFacetRefined(facet, value);
      }

      if (typeof state.getRefinements === 'function') {
        return state.getRefinements(facet).some(function(refinement) {
          return refinement && refinement.value === value;
        });
      }

      return false;
    };

    instant.search.addWidgets([
      {
        init: function(opts) {
          var container = document.querySelector('.ais-sheet-music-shortcuts');

          if (!container) {
            return;
          }

          container.addEventListener('click', function(event) {
            var button = event.target.closest('.ais-sheet-filter-chip');

            if (!button) {
              return;
            }

            event.preventDefault();

            var facet = button.dataset.facet;
            var value = button.dataset.value;

            if (!facet || !value) {
              return;
            }

            var didToggle = toggleSheetMusicQuickFilterRefinement(opts.helper, facet, value);
            if (!didToggle) {
              return;
            }

            opts.helper.setPage(0).search();
          });
        },
        render: function(opts) {
          var container = document.querySelector('.ais-sheet-music-shortcuts');

          if (!container) {
            return;
          }

          Array.prototype.slice
            .call(container.querySelectorAll('.ais-sheet-filter-chip'))
            .forEach(function(button) {
              var facet = button.dataset.facet;
              var value = button.dataset.value;
              var isRefined = isQuickFilterRefined(opts.state, facet, value);

              button.classList.toggle('is-active', isRefined);
            });
        },
      },
    ]);
  }

  // Logo & clear
  instant.search.addWidgets([
    {
      init: function(opts) {
        document
          .querySelector('.ais-clear-input-icon')
          .addEventListener('click', function() {
            opts.helper.setQuery('').search();
            var input =
              document.querySelector('.ais-search-box--input') ||
              document.querySelector('.ais-SearchBox-input');

            if (input) {
              input.value = '';
              input.focus();
            }
          });
      },
      render: function(opts) {
        if (!opts.state.query) {
          document.querySelector('.ais-clear-input-icon').style.display =
            'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
        }
      },
    },
  ]);

  // Stats
  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text(data, {html}){
          return algolia.instantSearchStatsTemplate(data, html)
        }
      }
    }),
  ]);

  // Keep the browser title aligned with the rendered Algolia result count.
  if (algolia.full_results && !isSheetMusicStandalonePage) {
    instant.search.addWidgets([
      {
        render: function(renderOptions) {
          var results = renderOptions && renderOptions.results;
          var query = results && String(results.query || '').trim();
          var count = results && results.nbHits;
          if (!query || typeof count !== 'number') {
            return;
          }
          document.title =
            'Search: ' +
            count +
            (count === 1 ? ' result found for "' : ' results found for "') +
            query +
            '"';
        },
      },
    ]);
  }

  // Sort orders
  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
      }),
    ]);
  }

  // Change display
  instant.search.addWidgets([
    {
      init: function() {
        document
          .querySelector('.ais-search-header .ais-change-display-block')
          .addEventListener('click', function() {
            document
              .querySelector(
                '.ais-change-display-block:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-list.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-list')
              .classList.replace('ais-results-as-list', 'ais-results-as-block');
          });
        document
          .querySelector('.ais-search-header .ais-change-display-list')
          .addEventListener('click', function() {
            document
              .querySelector(
                '.ais-change-display-list:not(.ais-change-display-selected)'
              )
              .classList.add('ais-change-display-selected');
            document
              .querySelector(
                '.ais-change-display-block.ais-change-display-selected'
              )
              .classList.remove('ais-change-display-selected');
            document
              .querySelector('.ais-results-as-block')
              .classList.replace('ais-results-as-block', 'ais-results-as-list');
          });
      },
    },
  ]);

  // Hidden facets
  var list = instant.facets.hidden.map(function(facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function() {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function() {},
    },
  ]);

  // Create the render function
  var createDataAttributes = function(refinement) {
    return Object.keys(refinement)
      .map(function(key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function(item) {
    var facet = instant.facets.list.find(function(f) {
      return f.name === item.label;
    });
    var facetTitle = facet && facet.title ? facet.title : item.label;
    return item.refinements
      .map(function(refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a ' +
          createDataAttributes(refinement) +
          '    class="ais-current-refined-values--link">' +
          '    <div>' +
          '      <div class="ais-current-refined-values--label">' +
          facetTitle +
          '      </div>: ' +
          refinement.label +
          '    </div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };

  var renderCurrentRefinements = function(renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;

    widgetParams.container.innerHTML =
      '<div class="ais-current-refined-values--header ais-facet--header ais-header">Selected filters</div>' +
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function(element) {
        element.addEventListener('click', function(event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function(
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
          {});

          refine(item);
        });
      });
  };

  // Create the custom widget
  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function(helper, facetsList) {
    if (
      helper &&
      helper.state &&
      typeof helper.state.isTagRefined === 'function' &&
      Array.isArray(helper.state.tagRefinements) &&
      helper.state.tagRefinements.some(function(tagValue) {
        return helper.state.isTagRefined(tagValue);
      })
    ) {
      return true;
    }

    return facetsList.some(function(f) {
      var isConjunctiveFacetRefined =
        helper.state.isConjunctiveFacet(f.name) &&
        helper.state.isFacetRefined(f.name);
      var isDisjunctiveFacetRefined =
        helper.state.isDisjunctiveFacet(f.name) &&
        helper.state.isDisjunctiveFacetRefined(f.name);
      var isHierarchicalFacetRefined =
        helper.state.isHierarchicalFacet(f.name) &&
        helper.state.isHierarchicalFacetRefined(f.name);

      var numericRefinements = helper.state.getNumericRefinements(f.name);
      var isNumericFacetRefined = Object.keys(numericRefinements).some(function(
        operator
      ) {
        return numericRefinements[operator].length > 0;
      });

      return (
        isNumericFacetRefined ||
        isConjunctiveFacetRefined ||
        isDisjunctiveFacetRefined ||
        isHierarchicalFacetRefined
      );
    });
  };

  /**
   * Decides whether the given `facetName` has any facet values available in
   * the current result set by checking the available `facets`,
   * `disjunctiveFacets` and `hierarchicalFacets`.
   */
  var hasFacetValues = function(resultState, facetName) {
    var isFacetValueAvailable = resultState.facets.some(function(facet) {
      return facet.name === facetName;
    });
    var isDisjunctiveFacetValueAvailable = resultState.disjunctiveFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );
    var isHierarchicalFacetValueAvailable = resultState.hierarchicalFacets.some(
      function(facet) {
        return facet.name === facetName;
      }
    );

    return (
      isFacetValueAvailable ||
      isDisjunctiveFacetValueAvailable ||
      isHierarchicalFacetValueAvailable
    );
  };

  var localFacetSearchQueryByFacet = {};
  var localFacetSortModeByFacet = {};
  var sortableSheetMusicFacets = isSheetMusicExperience
    ? (
        Array.isArray(algolia.sheetMusicSortableFacetAttributes) &&
        algolia.sheetMusicSortableFacetAttributes.length > 0
          ? algolia.sheetMusicSortableFacetAttributes
          : localFacetSearchFacets
      )
        .filter(function(facetName, index, values) {
          return values.indexOf(facetName) === index;
        })
    : [];

  var getFacetWrapper = function(facetName) {
    var escapedFacetClassName = encodeURIComponent(facetName)
      .replace(/\./g, '\\.')
      .replace(/\%/g, '\\%');

    return document.querySelector('.ais-facet-' + escapedFacetClassName);
  };

  var normalizeFacetSearchTerm = function(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  };

  var getFacetItemLabelText = function(item) {
    if (!item) {
      return '';
    }

    var itemLabel = item.querySelector('.ais-facet--label');

    if (!itemLabel) {
      return '';
    }

    var titleValue = itemLabel.getAttribute('title');
    if (titleValue) {
      return titleValue.toString().trim();
    }

    var labelClone = itemLabel.cloneNode(true);
    Array.prototype.slice
      .call(
        labelClone.querySelectorAll(
          '.ais-facet--count, .ais-facet--count-distinct, .ais-facet--checkbox'
        )
      )
      .forEach(function(node) {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });

    return (labelClone.textContent || '').trim();
  };

  var captureFacetOriginalOrder = function(facetName) {
    var wrapper = getFacetWrapper(facetName);

    if (!wrapper) {
      return;
    }

    Array.prototype.slice
      .call(
        wrapper.querySelectorAll(
          '.ais-RefinementList-list > .ais-RefinementList-item'
        )
      )
      .forEach(function(item, index) {
        item.dataset.localFacetOriginalIndex = String(index);
        item.dataset.localFacetSortLabel = getFacetItemLabelText(item);
      });
  };

  var updateFacetSortControls = function(facetName) {
    var wrapper = getFacetWrapper(facetName);

    if (!wrapper) {
      return;
    }

    var activeMode = localFacetSortModeByFacet[facetName] || 'default';

    Array.prototype.slice
      .call(wrapper.querySelectorAll('.ais-sheet-facet-sort-button'))
      .forEach(function(button) {
        var isActive = button.dataset.sortMode === activeMode;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
  };

  var applyFacetSort = function(facetName) {
    var wrapper = getFacetWrapper(facetName);

    if (!wrapper) {
      return;
    }

    var listNode = wrapper.querySelector('.ais-RefinementList-list');
    if (!listNode) {
      return;
    }

    var items = Array.prototype.slice
      .call(listNode.children)
      .filter(function(node) {
        return (
          node.classList && node.classList.contains('ais-RefinementList-item')
        );
      });

    if (!items.length) {
      return;
    }

    var sortMode = localFacetSortModeByFacet[facetName] || 'default';

    items.sort(function(a, b) {
      if (sortMode === 'alpha') {
        var labelA =
          a.dataset.localFacetSortLabel || getFacetItemLabelText(a) || '';
        var labelB =
          b.dataset.localFacetSortLabel || getFacetItemLabelText(b) || '';

        return labelA.localeCompare(labelB, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      }

      return (
        Number(a.dataset.localFacetOriginalIndex || 0) -
        Number(b.dataset.localFacetOriginalIndex || 0)
      );
    });

    items.forEach(function(item) {
      listNode.appendChild(item);
    });

    updateFacetSortControls(facetName);
  };

  var ensureFacetSortControls = function(facetName) {
    var wrapper = getFacetWrapper(facetName);

    if (!wrapper) {
      return;
    }

    var refinementListRoot = wrapper.querySelector('.ais-RefinementList');

    if (!refinementListRoot) {
      return;
    }

    var sortContainer = refinementListRoot.querySelector('.ais-sheet-facet-sort');

    if (!sortContainer) {
      sortContainer = document.createElement('div');
      sortContainer.className = 'ais-sheet-facet-sort';

      var sortLabel = document.createElement('span');
      sortLabel.className = 'ais-sheet-facet-sort-label';
      sortLabel.textContent = 'Sort';

      var buttons = document.createElement('div');
      buttons.className = 'ais-sheet-facet-sort-buttons';

      [
        { value: 'default', label: 'Default' },
        { value: 'alpha', label: 'A-Z' },
      ].forEach(function(option) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ais-sheet-facet-sort-button';
        button.dataset.facetName = facetName;
        button.dataset.sortMode = option.value;
        button.textContent = option.label;
        button.addEventListener('click', function(event) {
          localFacetSortModeByFacet[facetName] =
            event.currentTarget.dataset.sortMode || 'default';

          if (localFacetSearchFacets.indexOf(facetName) !== -1) {
            applyFacetSearchFilter(facetName);
            return;
          }

          applyFacetSort(facetName);
        });
        buttons.appendChild(button);
      });

      sortContainer.appendChild(sortLabel);
      sortContainer.appendChild(buttons);

      var searchNode = refinementListRoot.querySelector('.ais-sheet-facet-search');
      var listNode = refinementListRoot.querySelector('.ais-RefinementList-list');
      refinementListRoot.insertBefore(
        sortContainer,
        searchNode || listNode || refinementListRoot.firstChild
      );
    }

    updateFacetSortControls(facetName);
  };

  var ensureFacetSearchInput = function(facetName, title) {
    var wrapper = getFacetWrapper(facetName);

    if (!wrapper) {
      return;
    }

    var refinementListRoot = wrapper.querySelector('.ais-RefinementList');

    if (!refinementListRoot) {
      return;
    }

    // Remove Algolia server-side facet search box for local facet-search mode.
    var instantSearchBox = refinementListRoot.querySelector('.ais-SearchBox');
    if (instantSearchBox && instantSearchBox.parentNode) {
      instantSearchBox.parentNode.removeChild(instantSearchBox);
    }

    var searchContainer = refinementListRoot.querySelector(
      '.ais-sheet-facet-search'
    );

    if (!searchContainer) {
      searchContainer = document.createElement('div');
      searchContainer.className = 'ais-sheet-facet-search';

      var searchInput = document.createElement('input');
      searchInput.type = 'search';
      searchInput.className = 'ais-sheet-facet-search-input';
      searchInput.setAttribute('data-facet-name', facetName);
      searchInput.setAttribute('autocomplete', 'off');
      searchInput.setAttribute('spellcheck', 'false');
      searchInput.placeholder = 'Type to search ' + title;

      var searchIcon = document.createElement('span');
      searchIcon.className = 'ais-sheet-facet-search-icon';
      searchIcon.innerHTML = '&#128269;';

      searchContainer.appendChild(searchInput);
      searchContainer.appendChild(searchIcon);

      searchInput.addEventListener('input', function(event) {
        localFacetSearchQueryByFacet[facetName] = event.currentTarget.value;
        applyFacetSearchFilter(facetName);
      });

      var listNode = refinementListRoot.querySelector('.ais-RefinementList-list');
      refinementListRoot.insertBefore(searchContainer, listNode || refinementListRoot.firstChild);
    }

    var emptyStateNode = refinementListRoot.querySelector(
      '.ais-sheet-facet-search-empty'
    );
    if (!emptyStateNode) {
      emptyStateNode = document.createElement('div');
      emptyStateNode.className = 'ais-sheet-facet-search-empty';
      emptyStateNode.textContent = 'No matching values';

      var searchNode = refinementListRoot.querySelector('.ais-sheet-facet-search');
      if (searchNode && searchNode.nextSibling) {
        refinementListRoot.insertBefore(emptyStateNode, searchNode.nextSibling);
      } else {
        refinementListRoot.appendChild(emptyStateNode);
      }
    }

    var existingInput = refinementListRoot.querySelector(
      '.ais-sheet-facet-search-input'
    );
    if (existingInput) {
      existingInput.value = localFacetSearchQueryByFacet[facetName] || '';
    }
  };

  var applyFacetSearchFilter = function(facetName) {
    var wrapper = getFacetWrapper(facetName);

    if (!wrapper) {
      return;
    }

    var searchInput = wrapper.querySelector('.ais-sheet-facet-search-input');
    var query = normalizeFacetSearchTerm(
      searchInput ? searchInput.value : localFacetSearchQueryByFacet[facetName]
    );
    localFacetSearchQueryByFacet[facetName] = query;

    var matchingCount = 0;
    Array.prototype.slice
      .call(
        wrapper.querySelectorAll(
          '.ais-RefinementList-list > .ais-RefinementList-item'
        )
      )
      .forEach(function(item) {
        var facetText =
          item.dataset.localFacetSearchText ||
          normalizeFacetSearchTerm(getFacetItemLabelText(item) || item.textContent);

        item.dataset.localFacetSearchText = facetText;

        var matches = !query || facetText.indexOf(query) !== -1;
        item.style.display = matches ? '' : 'none';

        if (matches) {
          matchingCount += 1;
        }
      });

    applyFacetSort(facetName);

    var noResultNode = wrapper.querySelector('.ais-sheet-facet-search-empty');
    if (noResultNode) {
      noResultNode.classList.toggle(
        'is-visible',
        Boolean(query) && matchingCount === 0
      );
    }

    var showMoreButton = wrapper.querySelector('.ais-RefinementList-showMore');
    if (showMoreButton) {
      showMoreButton.style.display = query ? 'none' : '';
    }
  };

  var enforceSheetMusicFacetListStyles = function() {
    if (!isSheetMusicExperience) {
      return;
    }

    Array.prototype.slice
      .call(
        document.querySelectorAll(
          '.ais-page--sheet-music .ais-facet-dropdown-wrapper .ais-RefinementList-list'
        )
      )
      .forEach(function(list) {
        list.style.maxHeight = '280px';
        list.style.overflowY = 'auto';
        list.style.overflowX = 'hidden';
      });

    Array.prototype.slice
      .call(
        document.querySelectorAll(
          '.ais-page--sheet-music .ais-facet-tags, .ais-page--sheet-music .ais-facet-hidden'
        )
      )
      .forEach(function(wrapper) {
        wrapper.style.display = 'none';
      });
  };

  var customCurrentRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
    hidden: function(options) {
      return !hasRefinements(options.helper, instant.facets.list);
    },
  })(clearRefinements);

  instant.search.addWidgets([
    clearRefinementsWithPanel({
      container: document.querySelector('.ais-clear-refinements-container'),
      templates: {
        resetLabel: algolia.translations.clearAll,
      },
    }),
    customCurrentRefinementsWithPanel({
      container: document.querySelector(
        '.ais-current-refined-values-container'
      ),
    }),
  ]);

  /**
   * Setup the facets for search.
   * We are using a `panel` with a custom `hidden` function which will allow
   * us to hide the parent container of the facet if there are no facet values
   * available for that particular facet.
   */
  instant.facets.widgets.forEach(function(widget) {
    var facetWithPanel = panel({
      hidden: function(options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';

        /**
         * Replacing any "." and "%" in the class name with "\." and "\%" so that querySelector
         * can work as expected. "." is supposed to be present for named tags
         * and metafield based facet names and "%" is present when the facet name has a space
         * in it because of the encoding.
         */
        var parentContainerClassName = '.ais-facet-' + encodeURIComponent(
          widget.params.attribute
        ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widget.params)]);
  });

  if (isSheetMusicExperience) {
    instant.search.addWidgets([
      {
        render: function() {
          enforceSheetMusicFacetListStyles();
          collapseSheetMusicFacetPanelsOnLoad();
          syncSheetMusicTopControlsAlignment();
        },
      },
    ]);
  }

  if (isSheetMusicExperience && sortableSheetMusicFacets.length > 0) {
    instant.search.addWidgets([
      {
        render: function() {
          enforceSheetMusicFacetListStyles();
          collapseSheetMusicFacetPanelsOnLoad();

          sortableSheetMusicFacets.forEach(function(facetName) {
            captureFacetOriginalOrder(facetName);
            ensureFacetSortControls(facetName);
          });

          if (localFacetSearchFacets.length > 0) {
            localFacetSearchFacets.forEach(function(facetName) {
              var facet = instant.facets.list.find(function(item) {
                return item.name === facetName;
              });

              ensureFacetSearchInput(
                facetName,
                facet && facet.title ? facet.title : facetName
              );
              applyFacetSearchFilter(facetName);
            });
          }

          sortableSheetMusicFacets
            .filter(function(facetName) {
              return localFacetSearchFacets.indexOf(facetName) === -1;
            })
            .forEach(function(facetName) {
              applyFacetSort(facetName);
            });
          syncSheetMusicTopControlsAlignment();
        },
      },
    ]);
  }

  var sheetMusicPreviewDataByObjectId = {};

  // Hits
  instant.search.addWidgets([
    hits({
      container: '.ais-hits-container',
      templates: {
        item(hit, {html, components}) {
          return algolia.instantSearchProductTemplate(hit, html, components);
        },
        empty(results, {html}) {
          return algolia.instantSearchNoResultTemplate(html);
        }
      },
      transformItems: function(items) {
        var activeQuery =
          instant.search &&
          instant.search.helper &&
          instant.search.helper.state &&
          typeof instant.search.helper.state.query === 'string'
            ? instant.search.helper.state.query
            : '';
        var shouldComputeTocMatch =
          isSheetMusicExperience && Boolean(activeQuery && activeQuery.trim());

        return items.map(function(item) {
          var tocMatchLine = '';

          if (item && item.objectID) {
            var indexedPreviewData = {
              body_html_safe: item.body_html_safe || '',
              meta: item.meta || {},
              flat_meta_next_cart_instrumentation:
                item['meta.next_cart.instrumentation'] || '',
              flat_meta_next_cart_publisher_item_number:
                item['meta.next_cart.publisher_item_number'] || '',
              flat_meta_next_cart_toc: item['meta.next_cart.toc'] || '',
              flat_meta_next_cart_table_of_contents: item['meta.next_cart.table_of_contents'] || '',
              flat_meta_next_cart_tableofcontents: item['meta.next_cart.tableofcontents'] || '',
              flat_meta_next_cart_contents: item['meta.next_cart.contents'] || '',
              flat_meta_next_cart_textblock8: item['meta.next_cart.textblock8'] || '',
              title: item.title || '',
            };

            if (shouldComputeTocMatch) {
              var tocFromMeta = extractSheetMusicPreviewTocFromMeta(
                indexedPreviewData.meta || {}
              );
              var tocFromFlatFields = tocFromMeta
                ? ''
                : extractSheetMusicPreviewTocFromFlatHitFields(indexedPreviewData);
              var tocFromPlainBody = tocFromMeta || tocFromFlatFields
                ? ''
                : extractSheetMusicPreviewTocFromPlainBodyText(
                    indexedPreviewData.body_html_safe || ''
                  );
              var tocForMatching =
                tocFromMeta || tocFromFlatFields || tocFromPlainBody || '';

              tocMatchLine = findSheetMusicPreviewTocMatchLine(
                tocForMatching,
                activeQuery
              );
            }

            indexedPreviewData.toc_match = Boolean(tocMatchLine);
            indexedPreviewData.toc_match_line = tocMatchLine;

            sheetMusicPreviewDataByObjectId[String(item.objectID)] = indexedPreviewData;
          }

          return {
            ...item,
            _distinct: instant.distinct,
            _toc_match: Boolean(tocMatchLine),
            _toc_match_line: tocMatchLine,
            can_order:
              item.inventory_management !== 'shopify' ||
              item.inventory_policy === 'continue' ||
              item.inventory_quantity > 0,
            queryID: item.__queryID,
            productPosition: item.__position,
            index: instant.search.mainIndex.getIndexName(),
          };
        });
      }
    })
  ]);

  var sheetMusicPreviewModeStorageKey = 'cnmc_sheet_music_preview_mode';
  var sheetMusicPreviewAllowedModes = {button: true, hover: true, off: true};
  var sheetMusicPreviewFallbackImage =
    'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
  var sheetMusicPreviewState = {
    mode: 'button',
    activeObjectId: null,
  };
  var sheetMusicPreviewHideTimer = null;

  var clampNumber = function(value, min, max) {
    return Math.min(Math.max(value, min), max);
  };

  var getSheetMusicPageRoot = function() {
    if (!instant.$results) {
      return null;
    }

    return instant.$results.querySelector('.ais-page--sheet-music');
  };

  var getSheetMusicHitsContainer = function() {
    return document.querySelector('.ais-hits-container');
  };

  var getSheetMusicPreviewCard = function() {
    return document.querySelector('.ais-sheet-hit-preview');
  };

  var clearSheetMusicPreviewHideTimer = function() {
    if (sheetMusicPreviewHideTimer) {
      clearTimeout(sheetMusicPreviewHideTimer);
      sheetMusicPreviewHideTimer = null;
    }
  };

  var parseBackgroundImageUrl = function(backgroundImageValue) {
    if (!backgroundImageValue || backgroundImageValue === 'none') {
      return '';
    }

    var matchedUrl = backgroundImageValue.match(/^url\((.*)\)$/);
    if (!matchedUrl || matchedUrl.length < 2) {
      return '';
    }

    return matchedUrl[1].replace(/^['"]|['"]$/g, '');
  };

  var collapseTextContent = function(node) {
    return node ? (node.textContent || '').replace(/\s+/g, ' ').trim() : '';
  };
  var SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS = 300;
  var SHEET_MUSIC_PREVIEW_TOC_TEXT_MAX_LENGTH = 18000;

  var stripSheetMusicPreviewFormattingArtifacts = function(value) {
    var text = (value || '').toString();

    // Remove common copied CSS rule fragments (e.g. "p.p1 {margin: ...}").
    text = text.replace(/\b[a-z]+\.[a-z0-9_-]+\s*\{[^}]+\}/gi, ' ');

    // Remove common CSS declarations when they leak without selector wrappers.
    text = text.replace(
      /\b(?:margin|padding|font(?:-family|-size|-weight|-style)?|line-height|letter-spacing|text-align|color|background(?:-color)?|white-space|word-break|text-indent)\s*:\s*[^;{}]+;?/gi,
      ' '
    );

    return text.replace(/\s+/g, ' ').trim();
  };

  var truncateSheetMusicPreviewText = function(value, maxLength) {
    var text = (value || '').replace(/\s+/g, ' ').trim();

    if (!text || text.length <= maxLength) {
      return text;
    }

    var shortened = text.slice(0, maxLength);
    var lastSpaceIndex = shortened.lastIndexOf(' ');

    if (lastSpaceIndex > Math.floor(maxLength * 0.7)) {
      shortened = shortened.slice(0, lastSpaceIndex);
    }

    return shortened.replace(/[,;:\s]+$/, '') + '…';
  };

  var truncateSheetMusicPreviewMultilineText = function(value, maxLength) {
    var text = (value || '')
      .replace(/[ \t]+/g, ' ')
      .replace(/\n{3,}/g, '\n\n')
      .trim();

    if (!text || text.length <= maxLength) {
      return text;
    }

    var shortened = text.slice(0, maxLength);
    var lastBreakIndex = Math.max(
      shortened.lastIndexOf('\n'),
      shortened.lastIndexOf(' ')
    );

    if (lastBreakIndex > Math.floor(maxLength * 0.65)) {
      shortened = shortened.slice(0, lastBreakIndex);
    }

    return shortened.replace(/[,;:\s]+$/, '') + '…';
  };

  var normalizeSheetMusicPreviewTocText = function(value) {
    var text = (value || '').toString();

    // Remove common copied CSS rule fragments (e.g. "p.p1 {margin: ...}").
    text = text.replace(/\b[a-z]+\.[a-z0-9_-]+\s*\{[^}]+\}/gi, ' ');

    // Remove common CSS declarations when they leak without selector wrappers.
    text = text.replace(
      /\b(?:margin|padding|font(?:-family|-size|-weight|-style)?|line-height|letter-spacing|text-align|color|background(?:-color)?|white-space|word-break|text-indent)\s*:\s*[^;{}]+;?/gi,
      ' '
    );

    text = text
      .replace(/\r\n?/g, '\n')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n[ \t]+/g, '\n')
      .replace(/^[ \t]*[•●◦▪·]+[ \t]*/gm, '')
      .replace(/^[ \t]*[.,;:|]+[ \t]*$/gm, '')
      .replace(/^[ \t]*[-–—]+[ \t]*$/gm, '');

    var hasDashDelimitedEntries = /\s+[—-]\s+/.test(text);

    if (!text) {
      return '';
    }

    // Preserve structure where possible instead of flattening into one sentence.
    text = text
      .replace(/\s*\|\s*/g, '\n')
      .replace(/[ \t]{2,}/g, ' ')
      .replace(/\s+(?=(?:Nr\.?|No\.?|Nº)\s*\d+\b)/gi, '\n')
      .replace(/\s+(?=\d+\.\s+)/g, '\n')
      .replace(/\n{2,}/g, '\n')
      .trim();

    // Semicolons often separate co-composers in dash-delimited TOCs.
    if (!hasDashDelimitedEntries) {
      text = text.replace(/\s*;\s*/g, '\n');
    }

    var lines = text
      .split('\n')
      .map(function(line) {
        return line.trim();
      })
      .filter(Boolean);

    if (lines.length === 0) {
      return '';
    }

    return truncateSheetMusicPreviewMultilineText(
      lines.join('\n'),
      SHEET_MUSIC_PREVIEW_TOC_TEXT_MAX_LENGTH
    );
  };

  var escapeSheetMusicPreviewHtml = function(value) {
    return (value || '')
      .toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  var buildSheetMusicPreviewTocLineHtml = function(value) {
    var line = (value || '')
      .toString()
      .replace(/\s+/g, ' ')
      .trim();

    if (!line) {
      return '';
    }

    var match = line.match(/^(.+?)\s+[—-]\s+(.+)$/);
    if (!match) {
      return escapeSheetMusicPreviewHtml(line);
    }

    return (
      '<strong>' +
      escapeSheetMusicPreviewHtml(match[1]) +
      '</strong> ' +
      '<span class="ais-sheet-hit-preview__toc-separator">—</span> ' +
      escapeSheetMusicPreviewHtml(match[2])
    );
  };

  var buildSheetMusicPreviewSafeInlineHtmlFromNode = function(node) {
    if (!node) {
      return '';
    }

    if (node.nodeType === Node.TEXT_NODE) {
      return escapeSheetMusicPreviewHtml(node.textContent || '');
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }

    var tagName = (node.tagName || '').toLowerCase();
    if (tagName === 'br') {
      return '<br />';
    }

    var innerHtml = Array.prototype.slice
      .call(node.childNodes || [])
      .map(buildSheetMusicPreviewSafeInlineHtmlFromNode)
      .join('');

    if (tagName === 'strong' || tagName === 'b' || tagName === 'em' || tagName === 'i') {
      return '<' + tagName + '>' + innerHtml + '</' + tagName + '>';
    }

    return innerHtml;
  };

  var sanitizeSheetMusicPreviewInlineHtml = function(value) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = value || '';

    return Array.prototype.slice
      .call(wrapper.childNodes || [])
      .map(buildSheetMusicPreviewSafeInlineHtmlFromNode)
      .join('')
      .replace(/\s+/g, ' ')
      .trim();
  };

  var getSheetMusicPreviewTextFromHtmlSnippet = function(value) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = value || '';

    return stripSheetMusicPreviewFormattingArtifacts(collapseTextContent(wrapper));
  };

  var splitSheetMusicPreviewTocByDashPattern = function(value) {
    var text = stripSheetMusicPreviewFormattingArtifacts(value || '')
      .replace(/[ \t]+/g, ' ')
      .replace(/\n+/g, ' ')
      .trim();

    if (!text || !/[—-]/.test(text)) {
      return [];
    }

    // Handles compact TOCs like: "Title A — Composer X Title B — Composer Y".
    var pattern = /(.+?)\s+[—-]\s+(.+?)(?=(?:\s+(?:(?:A|I|O)\s+)?[A-Z0-9][^\s—-]{1,}[^\n]{0,136}?\s+[—-]\s+)|$)/g;
    var lines = [];
    var match;

    while ((match = pattern.exec(text)) !== null) {
      var title = (match[1] || '').trim();
      var credit = (match[2] || '').trim();

      if (!title || !credit) {
        continue;
      }

      lines.push(title + ' — ' + credit);
      if (lines.length >= SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS) {
        break;
      }
    }

    var normalizeSheetMusicPreviewComposerBlock = function(value) {
      return (value || '')
        .replace(/\s+(?=[A-Z][A-Za-z'.-]*(?:\s+[A-Z][A-Za-z'.-]*)*,\s*[A-Z]{1,3}\b)/g, '; ')
        .replace(/\s*;\s*/g, '; ')
        .replace(/\s{2,}/g, ' ')
        .trim();
    };

    var appendSheetMusicPreviewComposerBlock = function(line, composerBlock) {
      var parts = (line || '').split(/\s+[—-]\s+/);
      if (parts.length < 2) {
        return line;
      }

      var titlePart = parts.shift().trim();
      var creditPart = parts.join(' — ').trim();
      var normalizedComposer = normalizeSheetMusicPreviewComposerBlock(
        composerBlock
      );

      if (!normalizedComposer) {
        return line;
      }

      var joiner = '; ';
      if (/^(Jr|Sr)\b/i.test(normalizedComposer) && /[A-Za-z]$/.test(creditPart)) {
        joiner = ' ';
      }

      return (
        titlePart + ' — ' + (creditPart ? creditPart + joiner : '') + normalizedComposer
      )
        .replace(/\s+/g, ' ')
        .trim();
    };

    // Repair compact TOCs where co-composers leak into the next parsed title.
    var fixedLines = [];
    var composerPrefixPattern =
      /^((?:(?:[A-Z][A-Za-z'.-]*(?:\s+[A-Z][A-Za-z'.-]*)*),\s*[A-Z]{1,3}(?:\s*;?\s*)?)+)\s+(.+\s+[—-]\s+.+)$/;

    lines.forEach(function(line) {
      var nextLine = line;

      if (fixedLines.length > 0) {
        var composerPrefixMatch = nextLine.match(composerPrefixPattern);
        if (composerPrefixMatch) {
          fixedLines[fixedLines.length - 1] = appendSheetMusicPreviewComposerBlock(
            fixedLines[fixedLines.length - 1],
            composerPrefixMatch[1]
          );
          nextLine = composerPrefixMatch[2].trim();
        }
      }

      fixedLines.push(nextLine);
    });

    lines = fixedLines;

    return lines;
  };

  var splitSheetMusicPreviewTocLines = function(value) {
    var normalizedLines = normalizeSheetMusicPreviewTocText(value)
      .split('\n')
      .map(function(line) {
        return line
          .replace(/^[•●◦▪·]+\s*/, '')
          .replace(/\s+/g, ' ')
          .trim();
      })
      .filter(Boolean)
      .filter(function(line) {
        return !/^[.,;:|•●◦▪·-]+$/.test(line);
      });

    var composerOnlyLinePattern =
      /^(?:[A-Z][A-Za-z'.-]*(?:\s+[A-Z][A-Za-z'.-]*)*,\s*[A-Z]{1,3})(?:\s*;\s*[A-Z][A-Za-z'.-]*(?:\s+[A-Z][A-Za-z'.-]*)*,\s*[A-Z]{1,3})*$/;
    var mergedLines = [];

    normalizedLines.forEach(function(line) {
      if (
        mergedLines.length > 0 &&
        composerOnlyLinePattern.test(line) &&
        /\s+[—-]\s+/.test(mergedLines[mergedLines.length - 1])
      ) {
        mergedLines[mergedLines.length - 1] =
          mergedLines[mergedLines.length - 1] + '; ' + line;
        return;
      }

      mergedLines.push(line);
    });

    normalizedLines = mergedLines;

    if (normalizedLines.length > 1) {
      return normalizedLines.slice(0, SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS);
    }

    var dashSplitLines = splitSheetMusicPreviewTocByDashPattern(value);
    if (dashSplitLines.length > 1) {
      return dashSplitLines.slice(0, SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS);
    }

    return normalizedLines.slice(0, SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS);
  };

  var buildSheetMusicPreviewTocListHtmlFromLines = function(lines) {
    if (!lines || lines.length === 0) {
      return '';
    }

    var itemsHtml = lines
      .map(function(line) {
        return '<li>' + buildSheetMusicPreviewTocLineHtml(line) + '</li>';
      })
      .join('');

    return '<ul class="ais-sheet-hit-preview__toc-list">' + itemsHtml + '</ul>';
  };

  var buildSheetMusicPreviewTocListHtmlFromText = function(value) {
    return buildSheetMusicPreviewTocListHtmlFromLines(
      splitSheetMusicPreviewTocLines(value)
    );
  };

  var buildSheetMusicPreviewTocPayloadFromItems = function(textItems, htmlItems) {
    var normalizedTextItems = (textItems || [])
      .map(function(textItem) {
        return stripSheetMusicPreviewFormattingArtifacts(textItem || '');
      })
      .map(function(textItem) {
        return textItem.trim();
      })
      .filter(Boolean)
      .slice(0, SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS);

    if (normalizedTextItems.length === 0) {
      return {toc: '', tocHtml: ''};
    }

    var tocText = normalizeSheetMusicPreviewTocText(
      normalizedTextItems.join('\n')
    );

    if (!tocText) {
      return {toc: '', tocHtml: ''};
    }

    var cleanedHtmlItems = (htmlItems || [])
      .map(sanitizeSheetMusicPreviewInlineHtml)
      .map(function(htmlItem) {
        if (!htmlItem) {
          return '';
        }

        if (/<\s*(strong|b)\b/i.test(htmlItem)) {
          return htmlItem;
        }

        var textValue = getSheetMusicPreviewTextFromHtmlSnippet(htmlItem);
        return textValue ? buildSheetMusicPreviewTocLineHtml(textValue) : htmlItem;
      })
      .filter(Boolean)
      .slice(0, SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS);

    var tocHtml = '';
    if (cleanedHtmlItems.length > 0) {
      tocHtml =
        '<ul class="ais-sheet-hit-preview__toc-list">' +
        cleanedHtmlItems
          .map(function(htmlItem) {
            return '<li>' + htmlItem + '</li>';
          })
          .join('') +
        '</ul>';
    } else {
      tocHtml = buildSheetMusicPreviewTocListHtmlFromText(tocText);
    }

    return {
      toc: tocText,
      tocHtml: tocHtml,
    };
  };

  var extractSheetMusicPreviewDescriptionAndTocFromHtml = function(bodyHtml) {
    if (!bodyHtml) {
      return {description: '', toc: ''};
    }

    var wrapper = document.createElement('div');
    wrapper.innerHTML = bodyHtml;

    Array.prototype.slice
      .call(wrapper.querySelectorAll('style,script'))
      .forEach(function(node) {
        node.remove();
      });

    var fullText = stripSheetMusicPreviewFormattingArtifacts(
      collapseTextContent(wrapper)
    );

    if (!fullText) {
      return {description: '', toc: ''};
    }

    var tocSplitPatterns = [
      /\btable\s*of\s*contents\b\s*[:\-]?\s*/i,
      /\bcontents\b\s*[:\-]\s*/i,
      /\btoc\b\s*[:\-]\s*/i,
    ];

    for (var i = 0; i < tocSplitPatterns.length; i += 1) {
      var matchedPattern = tocSplitPatterns[i].exec(fullText);
      if (!matchedPattern) {
        continue;
      }

      var tocMarkerIndex = matchedPattern.index;
      var tocValue = fullText
        .slice(tocMarkerIndex + matchedPattern[0].length)
        .trim();

      if (tocValue.length < 12) {
        continue;
      }

      var descriptionValue = fullText.slice(0, tocMarkerIndex).trim();

      return {
        description: truncateSheetMusicPreviewText(
          descriptionValue || fullText,
          360
        ),
        toc: normalizeSheetMusicPreviewTocText(tocValue),
      };
    }

    return {
      description: truncateSheetMusicPreviewText(fullText, 360),
      toc: '',
    };
  };

  var extractSheetMusicPreviewDescription = function(bodyHtml) {
    return extractSheetMusicPreviewDescriptionAndTocFromHtml(bodyHtml)
      .description;
  };

  var extractSheetMusicPreviewTocFromMeta = function(meta) {
    var nextCart = meta && meta.next_cart ? meta.next_cart : {};
    var candidateKeys = [
      'toc',
      'table_of_contents',
      'tableofcontents',
      'contents',
      'textblock8',
    ];

    for (var i = 0; i < candidateKeys.length; i += 1) {
      var key = candidateKeys[i];
      if (typeof nextCart[key] === 'string' && nextCart[key].trim()) {
        return normalizeSheetMusicPreviewTocText(nextCart[key]);
      }
    }

    return '';
  };

  var extractSheetMusicPreviewTocFromFlatHitFields = function(hitData) {
    var candidateValues = [
      hitData && hitData.flat_meta_next_cart_toc,
      hitData && hitData.flat_meta_next_cart_table_of_contents,
      hitData && hitData.flat_meta_next_cart_tableofcontents,
      hitData && hitData.flat_meta_next_cart_contents,
      hitData && hitData.flat_meta_next_cart_textblock8,
    ];

    for (var i = 0; i < candidateValues.length; i += 1) {
      var value = candidateValues[i];
      if (typeof value === 'string' && value.trim()) {
        return normalizeSheetMusicPreviewTocText(value);
      }
    }

    return '';
  };

  var extractSheetMusicPreviewTocFromPlainBodyText = function(bodyHtml) {
    if (!bodyHtml) {
      return '';
    }

    var plainText = bodyHtml
      .replace(/<\s*br\s*\/?>/gi, '\n')
      .replace(/<\/(?:p|div|li|ul|ol|h1|h2|h3|h4|h5|h6|tr|td|th)>/gi, '\n')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/gi, ' ')
      .replace(/&#160;/gi, ' ')
      .replace(/\u00a0/g, ' ')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n[ \t]+/g, '\n')
      .replace(/[ \t]{2,}/g, ' ')
      .replace(/\n{3,}/g, '\n\n')
      .trim();

    if (!plainText) {
      return '';
    }

    var markerMatch = plainText.match(
      /(?:^|\n)\s*(?:table\s*of\s*contents|contents|toc)\s*[:\-]?\s*(?:\n|$)/i
    );

    if (!markerMatch) {
      return '';
    }

    var markerIndex = plainText.indexOf(markerMatch[0]);
    var afterMarkerText = plainText
      .slice(markerIndex + markerMatch[0].length)
      .trim();

    if (!afterMarkerText || afterMarkerText.length < 12) {
      return '';
    }

    var lines = afterMarkerText
      .split(/\n+/)
      .map(function(line) {
        return line.replace(/^[\-\*\s]+/, '').trim();
      })
      .filter(Boolean);

    if (lines.length === 0) {
      return '';
    }

    return normalizeSheetMusicPreviewTocText(
      lines.slice(0, SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS).join('\n')
    );
  };

  var extractSheetMusicPreviewTocRichFromHtml = function(bodyHtml) {
    if (!bodyHtml) {
      return {toc: '', tocHtml: ''};
    }

    var wrapper = document.createElement('div');
    wrapper.innerHTML = bodyHtml;

    Array.prototype.slice
      .call(wrapper.querySelectorAll('style,script'))
      .forEach(function(node) {
        node.remove();
      });

    var fullText = stripSheetMusicPreviewFormattingArtifacts(
      collapseTextContent(wrapper)
    );

    if (!/(table of contents|contents|toc)/i.test(fullText)) {
      return {toc: '', tocHtml: ''};
    }

    var buildPayloadFromElement = function(element) {
      if (!element) {
        return {toc: '', tocHtml: ''};
      }

      if (element.matches('ul,ol')) {
        var listItems = Array.prototype.slice
          .call(element.querySelectorAll(':scope > li'))
          .slice(0, SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS);

        return buildSheetMusicPreviewTocPayloadFromItems(
          listItems.map(collapseTextContent),
          listItems.map(function(item) {
            return item.innerHTML || '';
          })
        );
      }

      if (element.matches('table')) {
        var rows = Array.prototype.slice
          .call(element.querySelectorAll('tr'))
          .slice(0, SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS);

        return buildSheetMusicPreviewTocPayloadFromItems(
          rows.map(collapseTextContent),
          rows.map(function(row) {
            return row.innerHTML || '';
          })
        );
      }

      var elementHtml = element.innerHTML || '';
      if (/<\s*br\s*\/?>/i.test(elementHtml)) {
        var htmlLines = elementHtml
          .split(/<\s*br\s*\/?>/i)
          .map(function(line) {
            return line.trim();
          })
          .filter(Boolean)
          .slice(0, SHEET_MUSIC_PREVIEW_TOC_MAX_ITEMS);

        return buildSheetMusicPreviewTocPayloadFromItems(
          htmlLines.map(getSheetMusicPreviewTextFromHtmlSnippet),
          htmlLines
        );
      }

      return buildSheetMusicPreviewTocPayloadFromItems(
        [collapseTextContent(element)],
        [elementHtml]
      );
    };

    var headingNodes = Array.prototype.slice.call(
      wrapper.querySelectorAll('h1,h2,h3,h4,h5,strong,b,p,div,span')
    );

    for (var i = 0; i < headingNodes.length; i += 1) {
      var headingNode = headingNodes[i];
      var headingText = stripSheetMusicPreviewFormattingArtifacts(
        collapseTextContent(headingNode)
      );

      if (!/(table of contents|contents|toc)/i.test(headingText)) {
        continue;
      }

      var nextElement = headingNode.nextElementSibling;
      var payload = buildPayloadFromElement(nextElement);
      if (payload.toc) {
        return payload;
      }
    }

    var fallbackList = wrapper.querySelector('ul,ol');
    if (fallbackList) {
      var fallbackPayload = buildPayloadFromElement(fallbackList);
      if (fallbackPayload.toc) {
        return fallbackPayload;
      }
    }

    return {toc: '', tocHtml: ''};
  };

  var extractSheetMusicPreviewTocFromHtml = function(bodyHtml) {
    return extractSheetMusicPreviewTocRichFromHtml(bodyHtml).toc;
  };

  var extractSheetMusicPreviewOrchestration = function(hitData) {
    var nextCart = hitData && hitData.meta && hitData.meta.next_cart
      ? hitData.meta.next_cart
      : {};
    var candidateValues = [
      nextCart.instrumentation,
      hitData && hitData.flat_meta_next_cart_instrumentation,
    ];

    for (var i = 0; i < candidateValues.length; i += 1) {
      var value = candidateValues[i];
      if (typeof value === 'string' && value.trim()) {
        return truncateSheetMusicPreviewText(
          stripSheetMusicPreviewFormattingArtifacts(value),
          100
        );
      }
    }

    return '';
  };

  var sheetMusicPreviewStopWords = {
    a: true,
    an: true,
    and: true,
    by: true,
    for: true,
    in: true,
    no: true,
    of: true,
    op: true,
    the: true,
    to: true,
    vol: true,
    volume: true,
  };

  var normalizeSheetMusicPreviewSearchText = function(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .replace(/&nbsp;/gi, ' ')
      .replace(/&#160;/gi, ' ')
      .replace(/[\u00a0]/g, ' ')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201c\u201d]/g, '"')
      .replace(/[^a-z0-9'\s]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  var getSheetMusicPreviewQueryTerms = function(query) {
    var normalizedQuery = normalizeSheetMusicPreviewSearchText(query);
    if (!normalizedQuery) {
      return [];
    }

    return normalizedQuery
      .split(' ')
      .map(function(term) {
        return term.trim();
      })
      .filter(Boolean)
      .filter(function(term) {
        return term.length >= 2 && !sheetMusicPreviewStopWords[term];
      })
      .slice(0, 8);
  };

  var findSheetMusicPreviewTocMatchLine = function(tocText, query) {
    if (!tocText || !query) {
      return '';
    }

    var queryTerms = getSheetMusicPreviewQueryTerms(query);
    if (queryTerms.length === 0) {
      return '';
    }

    var lines = splitSheetMusicPreviewTocLines(tocText);
    if (!lines || lines.length === 0) {
      return '';
    }

    var bestLine = '';
    var bestScore = 0;

    lines.forEach(function(line) {
      var normalizedLine = normalizeSheetMusicPreviewSearchText(line);
      if (!normalizedLine) {
        return;
      }

      var score = 0;
      queryTerms.forEach(function(term) {
        if (normalizedLine.indexOf(term) !== -1) {
          score += 1;
        }
      });

      if (score > bestScore) {
        bestScore = score;
        bestLine = line;
      }
    });

    if (bestScore === 0) {
      return '';
    }

    if (queryTerms.length >= 3 && bestScore < 2) {
      return '';
    }

    return truncateSheetMusicPreviewText(bestLine, 140);
  };

  var getSheetMusicPreviewDataFromHit = function(hitNode) {
    if (!hitNode) {
      return null;
    }

    var titleLink = hitNode.querySelector('.ais-hit--title a');
    var subtitleNode = hitNode.querySelector('.ais-hit--subtitle');
    var priceNode = hitNode.querySelector('.ais-hit--price b');
    var pictureNode = hitNode.querySelector('.ais-hit--picture');
    var backgroundImage = pictureNode
      ? window.getComputedStyle(pictureNode).backgroundImage || pictureNode.style.backgroundImage
      : '';
    var objectId = hitNode.dataset.algoliaObjectid || '';
    var indexedPreviewData = objectId
      ? sheetMusicPreviewDataByObjectId[String(objectId)] || {}
      : {};
    var bodyHtmlSafe = indexedPreviewData.body_html_safe || '';
    var htmlDescriptionAndToc = extractSheetMusicPreviewDescriptionAndTocFromHtml(
      bodyHtmlSafe
    );
    var tocFromMeta = extractSheetMusicPreviewTocFromMeta(indexedPreviewData.meta || {});
    var tocFromFlatFields = tocFromMeta
      ? ''
      : extractSheetMusicPreviewTocFromFlatHitFields(indexedPreviewData);
    var tocFromPlainBody = tocFromMeta || tocFromFlatFields
      ? ''
      : extractSheetMusicPreviewTocFromPlainBodyText(bodyHtmlSafe);
    var tocFromHtmlRich = extractSheetMusicPreviewTocRichFromHtml(bodyHtmlSafe);
    var tocFromHtml = tocFromMeta
      ? ''
      : tocFromFlatFields || tocFromPlainBody || tocFromHtmlRich.toc || htmlDescriptionAndToc.toc;
    var finalTocValue =
      tocFromMeta || tocFromFlatFields || tocFromPlainBody || tocFromHtml;
    var finalTocHtml = tocFromHtmlRich.tocHtml || buildSheetMusicPreviewTocListHtmlFromText(finalTocValue);
    var previewMeta = indexedPreviewData.meta && indexedPreviewData.meta.next_cart
      ? indexedPreviewData.meta.next_cart
      : {};
    var publisherItemNumber = '';

    if (
      typeof previewMeta.publisher_item_number === 'string' &&
      previewMeta.publisher_item_number.trim()
    ) {
      publisherItemNumber = previewMeta.publisher_item_number.trim();
    } else if (
      typeof indexedPreviewData.flat_meta_next_cart_publisher_item_number === 'string' &&
      indexedPreviewData.flat_meta_next_cart_publisher_item_number.trim()
    ) {
      publisherItemNumber =
        indexedPreviewData.flat_meta_next_cart_publisher_item_number.trim();
    } else if (
      typeof hitNode.dataset.publisherItemNumber === 'string' &&
      hitNode.dataset.publisherItemNumber.trim()
    ) {
      publisherItemNumber = hitNode.dataset.publisherItemNumber.trim();
    }

    return {
      objectId: objectId,
      variantId: hitNode.dataset.variantId || objectId,
      canOrder: hitNode.dataset.canOrder !== 'false',
      title: collapseTextContent(titleLink),
      subtitle: collapseTextContent(subtitleNode),
      publisherItemNumber: publisherItemNumber,
      tocMatch: Boolean(indexedPreviewData.toc_match),
      tocMatchLine: indexedPreviewData.toc_match_line || '',
      orchestration: extractSheetMusicPreviewOrchestration(indexedPreviewData),
      price: collapseTextContent(priceNode),
      link: titleLink ? titleLink.href : '',
      image: parseBackgroundImageUrl(backgroundImage) || sheetMusicPreviewFallbackImage,
      description: htmlDescriptionAndToc.description || extractSheetMusicPreviewDescription(bodyHtmlSafe),
      toc: finalTocValue,
      tocHtml: finalTocHtml,
    };
  };

  var updateSheetMusicPreviewTriggerStates = function() {
    if (!isSheetMusicExperience) {
      return;
    }

    var container = getSheetMusicHitsContainer();
    if (!container) {
      return;
    }

    var previewCard = getSheetMusicPreviewCard();
    var isOpen = Boolean(previewCard && previewCard.classList.contains('is-visible'));

    Array.prototype.slice
      .call(container.querySelectorAll('.ais-hit-preview-trigger'))
      .forEach(function(trigger) {
        var hitNode = trigger.closest('.ais-hit');
        var isActive = Boolean(
          isOpen &&
          hitNode &&
          sheetMusicPreviewState.activeObjectId &&
          hitNode.dataset.algoliaObjectid === sheetMusicPreviewState.activeObjectId
        );

        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
  };

  var ensureSheetMusicPreviewCard = function() {
    var previewCard = getSheetMusicPreviewCard();

    if (previewCard) {
      return previewCard;
    }

    previewCard = document.createElement('aside');
    previewCard.className = 'ais-sheet-hit-preview';
    previewCard.setAttribute('aria-hidden', 'true');
    previewCard.innerHTML =
      '<button type="button" class="ais-sheet-hit-preview__close" aria-label="Close preview">×</button>' +
      '<div class="ais-sheet-hit-preview__columns">' +
      '  <div class="ais-sheet-hit-preview__main">' +
      '    <div class="ais-sheet-hit-preview__media"><img alt="" loading="lazy" /></div>' +
      '    <div class="ais-sheet-hit-preview__body">' +
      '      <p class="ais-sheet-hit-preview__title"></p>' +
      '      <p class="ais-sheet-hit-preview__subtitle"></p>' +
      '      <p class="ais-sheet-hit-preview__publisher-item-number"></p>' +
      '      <p class="ais-sheet-hit-preview__toc-match"></p>' +
      '      <p class="ais-sheet-hit-preview__orchestration"></p>' +
      '      <p class="ais-sheet-hit-preview__price"></p>' +
      '      <p class="ais-sheet-hit-preview__description"></p>' +
      '      <form class="ais-sheet-hit-preview__cart-form" action="/cart/add" method="post" enctype="multipart/form-data">' +
      '        <input class="ais-sheet-hit-preview__cart-id" type="hidden" name="id" value="" />' +
      '        <button type="submit" class="ais-sheet-hit-preview__cart-button">Add to cart</button>' +
      '      </form>' +
      '      <a class="ais-sheet-hit-preview__link" href="#">View Product</a>' +
      '    </div>' +
      '  </div>' +
      '  <div class="ais-sheet-hit-preview__toc">' +
      '    <p class="ais-sheet-hit-preview__toc-title">Table of Contents</p>' +
      '    <div class="ais-sheet-hit-preview__toc-content"></div>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(previewCard);
    return previewCard;
  };

  var hideSheetMusicPreview = function() {
    clearSheetMusicPreviewHideTimer();

    var previewCard = getSheetMusicPreviewCard();
    if (previewCard) {
      previewCard.classList.remove('is-visible');
      previewCard.classList.remove('has-toc');
      previewCard.setAttribute('aria-hidden', 'true');
      previewCard.removeAttribute('data-object-id');
    }

    sheetMusicPreviewState.activeObjectId = null;
    updateSheetMusicPreviewTriggerStates();
  };

  var positionSheetMusicPreview = function(hitNode) {
    var previewCard = getSheetMusicPreviewCard();
    if (!previewCard || !hitNode) {
      return;
    }

    var hitRect = hitNode.getBoundingClientRect();
    var cardRect = previewCard.getBoundingClientRect();
    var cardWidth = cardRect.width || 340;
    var cardHeight = cardRect.height || 420;
    var viewportPadding = 12;
    var gap = 14;
    var left = hitRect.right + gap;

    if (left + cardWidth > window.innerWidth - viewportPadding) {
      left = hitRect.left - cardWidth - gap;
    }

    if (left < viewportPadding) {
      left = window.innerWidth - cardWidth - viewportPadding;
    }

    left = clampNumber(
      left,
      viewportPadding,
      Math.max(viewportPadding, window.innerWidth - cardWidth - viewportPadding)
    );

    var top = clampNumber(
      hitRect.top + 8,
      viewportPadding,
      Math.max(viewportPadding, window.innerHeight - cardHeight - viewportPadding)
    );

    previewCard.style.left = left + 'px';
    previewCard.style.top = top + 'px';
  };

  var openSheetMusicPreview = function(hitNode) {
    if (!isSheetMusicExperience || !hitNode) {
      return;
    }

    var previewData = getSheetMusicPreviewDataFromHit(hitNode);
    if (!previewData) {
      return;
    }

    clearSheetMusicPreviewHideTimer();

    var previewCard = ensureSheetMusicPreviewCard();
    var imageNode = previewCard.querySelector('.ais-sheet-hit-preview__media img');
    var titleNode = previewCard.querySelector('.ais-sheet-hit-preview__title');
    var subtitleNode = previewCard.querySelector('.ais-sheet-hit-preview__subtitle');
    var publisherItemNumberNode = previewCard.querySelector(
      '.ais-sheet-hit-preview__publisher-item-number'
    );
    var tocMatchNode = previewCard.querySelector('.ais-sheet-hit-preview__toc-match');
    var orchestrationNode = previewCard.querySelector('.ais-sheet-hit-preview__orchestration');
    var priceNode = previewCard.querySelector('.ais-sheet-hit-preview__price');
    var descriptionNode = previewCard.querySelector('.ais-sheet-hit-preview__description');
    var tocNode = previewCard.querySelector('.ais-sheet-hit-preview__toc');
    var tocContentNode = previewCard.querySelector('.ais-sheet-hit-preview__toc-content');
    var cartFormNode = previewCard.querySelector('.ais-sheet-hit-preview__cart-form');
    var cartInputNode = previewCard.querySelector('.ais-sheet-hit-preview__cart-id');
    var cartButtonNode = previewCard.querySelector('.ais-sheet-hit-preview__cart-button');
    var linkNode = previewCard.querySelector('.ais-sheet-hit-preview__link');

    imageNode.src = previewData.image || sheetMusicPreviewFallbackImage;
    imageNode.alt = previewData.title || 'Product preview';

    titleNode.textContent = previewData.title || 'Untitled';
    subtitleNode.textContent = previewData.subtitle || '';
    subtitleNode.style.display = previewData.subtitle ? '' : 'none';

    publisherItemNumberNode.textContent = previewData.publisherItemNumber
      ? 'Publisher item #: ' + previewData.publisherItemNumber
      : '';
    publisherItemNumberNode.style.display = previewData.publisherItemNumber ? '' : 'none';

    tocMatchNode.textContent = previewData.tocMatch ? 'Contents match' : '';
    tocMatchNode.style.display = previewData.tocMatch ? '' : 'none';
    if (previewData.tocMatch && previewData.tocMatchLine) {
      tocMatchNode.title = previewData.tocMatchLine;
    } else {
      tocMatchNode.removeAttribute('title');
    }

    orchestrationNode.textContent = previewData.orchestration
      ? 'Orchestration: ' + previewData.orchestration
      : '';
    orchestrationNode.style.display = previewData.orchestration ? '' : 'none';

    priceNode.textContent = previewData.price || '';
    priceNode.style.display = previewData.price ? '' : 'none';

    descriptionNode.textContent = previewData.description || '';
    descriptionNode.style.display = previewData.description ? '' : 'none';

    var hasVariantId = Boolean(previewData.variantId);
    cartFormNode.style.display = hasVariantId ? '' : 'none';
    cartInputNode.value = hasVariantId ? previewData.variantId : '';
    cartButtonNode.disabled = !previewData.canOrder;
    cartButtonNode.textContent = previewData.canOrder
      ? (algolia.translations.addToCart || 'Add to cart')
      : (algolia.translations.outOfStock || 'Out of stock');
    cartButtonNode.classList.toggle(
      'ais-sheet-hit-preview__cart-button--disabled',
      !previewData.canOrder
    );

    var hasToc = Boolean(previewData.toc);
    if (previewData.tocHtml) {
      tocContentNode.innerHTML = previewData.tocHtml;
    } else {
      tocContentNode.textContent = previewData.toc || '';
    }
    tocNode.style.display = hasToc ? '' : 'none';
    previewCard.classList.toggle('has-toc', hasToc);

    if (previewData.link) {
      linkNode.href = previewData.link;
      linkNode.style.display = '';
    } else {
      linkNode.href = '#';
      linkNode.style.display = 'none';
    }

    sheetMusicPreviewState.activeObjectId = previewData.objectId || null;
    previewCard.dataset.objectId = previewData.objectId || '';
    previewCard.classList.add('is-visible');
    previewCard.setAttribute('aria-hidden', 'false');

    positionSheetMusicPreview(hitNode);
    updateSheetMusicPreviewTriggerStates();
  };

  var scheduleSheetMusicPreviewHide = function() {
    clearSheetMusicPreviewHideTimer();
    sheetMusicPreviewHideTimer = window.setTimeout(function() {
      hideSheetMusicPreview();
    }, 120);
  };

  var getSheetMusicHitFromTarget = function(target, container) {
    var element = target;

    while (element && element !== container) {
      if (element.matches && element.matches('.ais-hit')) {
        return element;
      }
      element = element.parentNode;
    }

    return null;
  };

  var applySheetMusicPreviewMode = function(mode, options) {
    if (!sheetMusicPreviewAllowedModes[mode]) {
      mode = 'button';
    }

    sheetMusicPreviewState.mode = mode;

    var root = getSheetMusicPageRoot();
    if (root) {
      root.setAttribute('data-sheet-preview-mode', mode);
    }

    Array.prototype.slice
      .call(document.querySelectorAll('.ais-sheet-preview-mode-button'))
      .forEach(function(button) {
        var isActive = button.dataset.previewMode === mode;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

    if (!options || options.persist !== false) {
      try {
        window.localStorage.setItem(sheetMusicPreviewModeStorageKey, mode);
      } catch (error) {
        // Ignore localStorage access failures (private browsing, restrictions).
      }
    }

    if (mode === 'off') {
      hideSheetMusicPreview();
    }
  };

  var loadSheetMusicPreviewMode = function() {
    try {
      var storedMode = window.localStorage.getItem(sheetMusicPreviewModeStorageKey);
      if (sheetMusicPreviewAllowedModes[storedMode]) {
        return storedMode;
      }
    } catch (error) {
      // Ignore localStorage access failures (private browsing, restrictions).
    }

    return 'button';
  };

  if (isSheetMusicExperience) {
    instant.search.addWidgets([
      {
        init: function() {
          var hitsContainer = getSheetMusicHitsContainer();
          if (!hitsContainer) {
            return;
          }

          ensureSheetMusicPreviewCard();
          applySheetMusicPreviewMode(loadSheetMusicPreviewMode(), {persist: false});

          var controls = document.querySelector('.ais-sheet-preview-controls');
          if (controls) {
            controls.addEventListener('click', function(event) {
              var modeButton = event.target.closest('.ais-sheet-preview-mode-button');
              if (!modeButton || !modeButton.dataset.previewMode) {
                return;
              }

              event.preventDefault();
              applySheetMusicPreviewMode(modeButton.dataset.previewMode);
            });
          }

          hitsContainer.addEventListener('click', function(event) {
            var trigger = event.target.closest('.ais-hit-preview-trigger');
            if (!trigger) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();

            if (sheetMusicPreviewState.mode === 'off') {
              applySheetMusicPreviewMode('button');
            }

            if (sheetMusicPreviewState.mode !== 'button') {
              return;
            }

            var hitNode = trigger.closest('.ais-hit');
            if (!hitNode) {
              return;
            }

            var previewCard = getSheetMusicPreviewCard();
            var isSameHit =
              previewCard &&
              previewCard.classList.contains('is-visible') &&
              sheetMusicPreviewState.activeObjectId &&
              sheetMusicPreviewState.activeObjectId === hitNode.dataset.algoliaObjectid;

            if (isSameHit) {
              hideSheetMusicPreview();
            } else {
              openSheetMusicPreview(hitNode);
            }
          });

          hitsContainer.addEventListener('mouseover', function(event) {
            if (sheetMusicPreviewState.mode !== 'hover') {
              return;
            }

            var hitNode = getSheetMusicHitFromTarget(event.target, hitsContainer);
            if (!hitNode) {
              return;
            }

            if (event.relatedTarget && hitNode.contains(event.relatedTarget)) {
              return;
            }

            openSheetMusicPreview(hitNode);
          });

          hitsContainer.addEventListener('mouseout', function(event) {
            if (sheetMusicPreviewState.mode !== 'hover') {
              return;
            }

            var hitNode = getSheetMusicHitFromTarget(event.target, hitsContainer);
            if (!hitNode) {
              return;
            }

            if (event.relatedTarget && hitNode.contains(event.relatedTarget)) {
              return;
            }

            var previewCard = getSheetMusicPreviewCard();
            if (previewCard && event.relatedTarget && previewCard.contains(event.relatedTarget)) {
              return;
            }

            scheduleSheetMusicPreviewHide();
          });

          var previewCard = getSheetMusicPreviewCard();
          if (previewCard) {
            previewCard.addEventListener('mouseenter', function() {
              clearSheetMusicPreviewHideTimer();
            });

            previewCard.addEventListener('mouseleave', function() {
              if (sheetMusicPreviewState.mode === 'hover') {
                scheduleSheetMusicPreviewHide();
              }
            });

            previewCard.addEventListener('click', function(event) {
              var closeButton = event.target.closest('.ais-sheet-hit-preview__close');
              if (!closeButton) {
                return;
              }

              event.preventDefault();
              hideSheetMusicPreview();
            });
          }

          document.addEventListener('click', function(event) {
            if (sheetMusicPreviewState.mode !== 'button') {
              return;
            }

            var preview = getSheetMusicPreviewCard();
            if (!preview || !preview.classList.contains('is-visible')) {
              return;
            }

            if (preview.contains(event.target)) {
              return;
            }

            if (event.target.closest('.ais-hit-preview-trigger')) {
              return;
            }

            hideSheetMusicPreview();
          });

          window.addEventListener(
            'scroll',
            function() {
              var preview = getSheetMusicPreviewCard();
              var hits = getSheetMusicHitsContainer();
              if (!preview || !hits || !preview.classList.contains('is-visible')) {
                return;
              }

              var activeHit = hits.querySelector(
                '.ais-hit[data-algolia-objectid="' + sheetMusicPreviewState.activeObjectId + '"]'
              );

              if (!activeHit) {
                hideSheetMusicPreview();
                return;
              }

              positionSheetMusicPreview(activeHit);
            },
            {passive: true}
          );

          window.addEventListener('resize', function() {
            var preview = getSheetMusicPreviewCard();
            var hits = getSheetMusicHitsContainer();
            if (!preview || !hits || !preview.classList.contains('is-visible')) {
              return;
            }

            var activeHit = hits.querySelector(
              '.ais-hit[data-algolia-objectid="' + sheetMusicPreviewState.activeObjectId + '"]'
            );

            if (!activeHit) {
              hideSheetMusicPreview();
              return;
            }

            positionSheetMusicPreview(activeHit);
          });
        },
        render: function() {
          applySheetMusicPreviewMode(sheetMusicPreviewState.mode, {persist: false});

          var previewCard = getSheetMusicPreviewCard();
          var hits = getSheetMusicHitsContainer();
          if (
            previewCard &&
            hits &&
            previewCard.classList.contains('is-visible') &&
            sheetMusicPreviewState.activeObjectId
          ) {
            var activeHit = hits.querySelector(
              '.ais-hit[data-algolia-objectid="' + sheetMusicPreviewState.activeObjectId + '"]'
            );

            if (activeHit) {
              positionSheetMusicPreview(activeHit);
            } else {
              hideSheetMusicPreview();
            }
          }

          updateSheetMusicPreviewTriggerStates();
        },
      },
    ]);
  }

  // Redirect to product on click
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          if (
            e.defaultPrevented ||
            (e.target && e.target.closest('a, button, input, select, textarea, label'))
          ) {
            return;
          }

          var el = e.target;
          var hit;
          do {
            if (el.matches('.ais-hit')) {
              hit = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!hit) {
            return;
          }
          var $this = hit;
          var productHandle = $this.dataset.handle;
          var variant_id = $this.dataset.variantId;
          var distinct = $this.dataset.distinct;

          // Construct the link we should redirect to
          var link = '';

          // If we're on a collection page and the handle is available
          // then prefix the product link with the collection handle
          if (collectionPageEnabled && collectionHandle) {
            link = `${window.Shopify.routes.root}collections/${collectionHandle}`;
          }

          // Add the product handle to the link
          link = link + `${window.Shopify.routes.root}products/${productHandle}`;

          // Add the variant ID details to redirect to a specific
          // variant ID if we are showing variants and not products
          if (distinct !== 'true') {
            link += '?variant=' + variant_id;
          }

          if (algolia.config.analytics_enabled) {

            const clickData = {
              index: hit.dataset.algoliaIndex,
              eventName: 'Add To Cart',
              queryID: hit.dataset.algoliaQueryid,
              objectIDs: [hit.dataset.algoliaObjectid],
            };

            algolia.saveForConversionTracking(clickData);
          }
          window.location.href = link;
        });
      },
    },
  ]);

  // Add to cart
  instant.search.addWidgets([
    {
      init: function() {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var cartButton;
          do {
            if (el.matches('.ais-hit--cart-button')) {
              cartButton = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!cartButton) {
            return;
          }

          e.stopPropagation();
          var $this = cartButton;
          var formId = $this.dataset.formId;

          if (formId) {
            document.getElementById(formId).submit();
          }
        });
      },
    },
  ]);

  // No result actions
  instant.search.addWidgets([
    {
      init: function(opts) {
        var container = document.querySelector('.ais-hits-container');
        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearFilters;
          do {
            if (el.matches('.ais-hit-empty--clear-filters')) {
              clearFilters = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearFilters) {
            return;
          }

          var helper = opts.helper;
          helper.clearTags();
          instant.facets.list.forEach(function(facet) {
            helper.clearRefinements(facet.name);
          });
          helper.search();
        });

        container.addEventListener('click', function(e) {
          var el = e.target;
          var clearInput;
          do {
            if (el.matches('.ais-hit-empty--clear-input')) {
              clearInput = el;
              break;
            }
            el = el.parentNode;
          } while (el && el !== container);
          if (!clearInput) {
            return;
          }

          opts.helper.setQuery('').search();
          var input =
            document.querySelector('.ais-search-box--input') ||
            document.querySelector('.ais-SearchBox-input');

          if (input) {
            input.value = '';
            input.focus();
          }
        });
      },
    },
  ]);

  // Pagination
  instant.search.addWidgets([
    pagination({
      container: '.ais-pagination-container',
      padding: 2,
      maxPages: 20,
    }),
  ]);

  instant.search.start();

  if (algolia.contentHide && algolia.contentHide.parentNode) {
    algolia.contentHide.parentNode.removeChild(algolia.contentHide);
  }
})(window.algoliaShopify);
